import React, { useState, useRef } from 'react'
import { SimulatorModel, SimulatorData } from './models/SimulatorModel'
import './assets/css/simulator_form_p0002.css'
import { SimulatorPageModel, Vehicle, CustomerAddress } from './models/superbit-api-models'
import { IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData } from './models/Site'
import { IDNameDescriptionItemSelect } from './components/_IDNameDescriptionItemSelect'
import { DynamicSelect } from './components/_DynamicSelect'
import { Autocomplete2 } from './components/_Autocomplete2'
import { Autocomplete } from './components/_Autocomplete'
import 'react-dropdown/style.css';
import $ from 'jquery';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { GlobalMethods } from './models/Site'
import { GeneralDataModel } from './models/GeneralDataModel';
import VehicleDetails from "./vehicles/_VehicleDetails"
import { createExpressionWithTypeArguments } from 'typescript';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import PostalCode from './Adrress/_PostalCode';
import PleaseWaitLayer from './components/_PleaseWaitLayer';
import CompDatePicker from './components/compDatePicker/_CompDatePicker';
import { ca, de } from 'date-fns/locale'
import moment from 'moment'
import { calculateAge } from "./utils/dateUtils";
import { AutoComplete } from 'antd';


class VehicleDetailsData {
    tozeretCd?: number;
    degemCd?: number;
    manufacturerId?: string;
    vehicleModelId?: string;
    vehicleSubModelId?: string;
    modelCode?: string;
    carYear?: number;
};

type Props = {
    data: SimulatorPageModel | null;
    loadOffers: any;
    loadRiders: any;
    startLoading: any;
    stopLoading: any;
    loadingOffers: boolean;
};
type State = {
    simulatorData: any;
    InsuranceTypes: IDNameDescriptionDictionary;
    AuthorizedToDrive: IDNameDescriptionDictionary;
    Geder: IDNameDescriptionDictionary;
    MaritalStatus: IDNameDescriptionDictionary;
    PassedTypeOfInsurance: IDNameDescriptionDictionary;
    VehicleOwnership: IDNameDescriptionDictionary;
    ImpairmentDeductible: IDNameDescriptionDictionary;
    RenovationAgentsOffice: IDNameDescriptionDictionary;
    RenovationCompany: IDNameDescriptionDictionary;
    CarYear: Array<string>;
    ModelcodeAutocomplete: Array<AutocompleteData>
    ManufacturerAll: Array<AutocompleteData>
    ManufacturerAutocomplete: Array<AutocompleteData>
    VehicleModelAutocomplete: Array<AutocompleteData>
    VehicleModelAll: Array<AutocompleteData>
    VehicleSubModelAutocomplete: Array<AutocompleteData>
    VehicleSubModelAll: Array<AutocompleteData>
    codeModelLoading: boolean;
    licenseLoading: boolean;
    startDateError: string;
    endDateError: string;
    youngAgeError: string;
    youngAgeError2: string;
    PostalcodeError: string;
    mainAgeError: string;
    seniorityYoungError: string;
    seniorityYoungError2: string;
    seniorityMainError: string;
    vehicleDetailsError: string;
    entryToRoadDateError: string;
    manufacturerError: string;
    vehicleModelError: string;
    vehicleSubModelError: string;

    Vehicle: VehicleDetailsData | null;
    ShowVehiclePopup: boolean;
    ShowAddressPopup: boolean;
    missingVehicleDetails: boolean;
    showVehicleDetails: boolean;
    lastLicense: string;
    lastmodelCode: string;
    enableViewOffers: boolean;
    loading: boolean;
    citiesAutocomplete: Array<AutocompleteData>
    postalCodeSpiner: boolean;
    clalMainFill: boolean;
};



export class SimulatorSidebar extends React.Component<Props, State> {
    private startDateRef: React.RefObject<DatePicker>;
    private driverYoungAgeRef: React.RefObject<DatePicker>;
    private driverMainAgeRef: React.RefObject<DatePicker>;
    private driverYoungSeniorityDateRef: React.RefObject<DatePicker>;
    private driverMainSeniorityDateRef: React.RefObject<DatePicker>;
    private entryToRoadDateRef: React.RefObject<DatePicker>;
    private insideGetModelDataByCode = false;
    // entryToRoadDate


    constructor(props: any) {
        super(props);

        this.state = {
            seniorityYoungError2: "",
            youngAgeError2: "",
            InsuranceTypes: new IDNameDescriptionDictionary(),
            AuthorizedToDrive: new IDNameDescriptionDictionary(),
            Geder: new IDNameDescriptionDictionary(),
            PassedTypeOfInsurance: new IDNameDescriptionDictionary(),
            MaritalStatus: new IDNameDescriptionDictionary(),
            VehicleOwnership: new IDNameDescriptionDictionary(),
            ImpairmentDeductible: new IDNameDescriptionDictionary(),
            RenovationAgentsOffice: new IDNameDescriptionDictionary(),
            RenovationCompany: new IDNameDescriptionDictionary(),
            CarYear: [],
            ModelcodeAutocomplete: [],
            ManufacturerAutocomplete: [],
            ManufacturerAll: new SimulatorModel().getManufacturers(),
            VehicleModelAutocomplete: [],
            VehicleModelAll: [],
            VehicleSubModelAutocomplete: [],
            VehicleSubModelAll: [],
            simulatorData: {
                InsuranceType: null,
                startDateSelectValue: null,
                deductible: false,
                insuranceStartDate: new Date(),
                lead_startDate: new Date(),
                lead_endDate: new Date(),
                lead_id: null,
                AuthorizedToDrive: 0,
                postalCode: null,
                driverYoungAge: null,
                driverYoungBirthDateSpecificDate: false,
                driverYoungSeniorityDateSpecificDate: false,
                driverMainBirthDateSpecificDate: false,
                driverMainSeniorityDateSpecificDate: false,
                driverYoungBirthDate: null,
                driverYoungSeniority: null,
                driverYoungSeniorityDate: null,
                driverYoungGender: null,
                driverYoungMaritalStatus: null,
                driverMainAge: null,
                driverMainBirthDate: null,
                driverMainSeniority: null,
                driverMainSeniorityDate: null,
                driverMainGender: null,
                driverMainMaritalStatus: null,
                esp: null,
                fcw: null,
                ldw: null,
                licenseNumber: null,
                licenseNumberLoading: false,
                modelCode: null,
                automaticInd: null,
                carYear: null,
                entryToRoadDate: null,
                manufacturer: null,
                vehicleModel: null,
                vehicleSubModel: null,
                passedTypeOfInsurance1: null,
                sueNumber1: null,
                passedTypeOfInsurance2: null,
                sueNumber2: null,
                passedTypeOfInsurance3: null,
                sueNumber3: null,
                passedTypeOfInsurance4: null,
                sueNumber4: null,
                sueBody: null,
                revocationsAmount: null,
                noInsurance: null,
                vehicleOwnership: null,
                impairmentDeductible: null,
                renovationAgentsOffice: null,
                renovationCompany: null,
                mainVehicle: null,
                autodirection: null,
                driveInShabbat: null,
                newForOld: null,
                firstName: null,
                phoneNumber1: null,
                city: "",
                cityId: null,
                address: "",
                street: "",
                houseNumber: ""
            },
            codeModelLoading: false,
            licenseLoading: false,
            startDateError: "",
            endDateError: "",
            youngAgeError: "",
            PostalcodeError: "",
            mainAgeError: "",
            seniorityYoungError: "",
            seniorityMainError: "",
            vehicleDetailsError: "",
            entryToRoadDateError: "",
            manufacturerError: "",
            vehicleModelError: "",
            vehicleSubModelError: "",

            Vehicle: null,
            ShowVehiclePopup: false,
            ShowAddressPopup: false,
            missingVehicleDetails: false,
            showVehicleDetails: false,
            lastLicense: "",
            lastmodelCode: "",
            enableViewOffers: false,
            loading: true,
            citiesAutocomplete: [],
            postalCodeSpiner: false,
            clalMainFill: false
        }

        this.setStateData = this.setStateData.bind(this);
        this.startDateSelectChange = this.startDateSelectChange.bind(this);
        this.loadModelCode = this.loadModelCode.bind(this);
        this.selectModelCode = this.selectModelCode.bind(this);

        this.loadManufacturer = this.loadManufacturer.bind(this);
        this.selectManufacturer = this.selectManufacturer.bind(this);

        this.loadVehicleModel = this.loadVehicleModel.bind(this);
        this.selectVehicleModel = this.selectVehicleModel.bind(this);

        this.loadVehicleSubModel = this.loadVehicleSubModel.bind(this);
        this.selectVehicleSubModel = this.selectVehicleSubModel.bind(this);

        this.getVehicleDetails = this.getVehicleDetails.bind(this);
        this.licenseNumberChange = this.licenseNumberChange.bind(this);
        this.getOffers = this.getOffers.bind(this);


        this.startDateRef = React.createRef<DatePicker>();
        this.driverYoungAgeRef = React.createRef<DatePicker>();
        this.driverMainAgeRef = React.createRef<DatePicker>();
        this.driverYoungSeniorityDateRef = React.createRef<DatePicker>();
        this.driverMainSeniorityDateRef = React.createRef<DatePicker>();
        this.entryToRoadDateRef = React.createRef<DatePicker>();

    }
    componentDidMount() {

        this.load();


    }


    async load() {
        // 
        var CarYear = [];
        for (let i: number = new Date().getFullYear() + 1; i >= new Date().getFullYear() - 31; i--) {
            CarYear.push(i + "");
        }
        this.setState({
            InsuranceTypes: await new SimulatorModel().getInsuranceTypes(),
            AuthorizedToDrive: await new SimulatorModel().getAuthorizedToDriveItems(),
            Geder: await new SimulatorModel().getGenderTypes(),
            PassedTypeOfInsurance: await new SimulatorModel().getPassedTypeOfInsurance(),
            MaritalStatus: await new SimulatorModel().getMaritalStatus(),
            VehicleOwnership: await new SimulatorModel().getVehicleOwnership(),
            ImpairmentDeductible: await new SimulatorModel().getImpairmentDeductible(),
            RenovationAgentsOffice: await new SimulatorModel().getRenovationAgentsOffice(),
            RenovationCompany: await new SimulatorModel().getRenovationCompany(),
            CarYear: CarYear,
            citiesAutocomplete: await new SimulatorModel().getCitiesAutocomplete()
            //ModelcodeAutocomplete:await new SimulatorModel().getModelCode("413")
        });



        var simData = this.state.simulatorData;

        // 
        if (this.props.data != null) {
            // 

            simData = {
                InsuranceType: this.props.data != null && this.props.data.lead != null ? this.props.data.lead.insuranceType : null,
                startDateSelectValue: this.props.data != null && this.props.data.startDateSelect != null ? this.props.data.startDateSelect.filter(function (x) { return x.selected; })[0].value : 0,
                deductible: this.props.data.lead != null ? this.props.data.lead.deductible : false,
                automaticInd: this.props.data.lead != null && this.props.data.lead.automaticInd != null ? this.props.data.lead.automaticInd : true,
                insuranceStartDate: this.props.data.lead != null && this.props.data.lead.startDate != null ? this.props.data.lead.startDate : new Date(),
                lead_startDate: this.props.data.lead != null && this.props.data.lead.startDate != null && new Date(this.props.data.lead.startDate) >= new Date() ? this.props.data.lead.startDate : new Date(),
                lead_endDate: this.props.data.lead != null && this.props.data.lead.endDate != null ? this.props.data.lead.endDate : new Date(),
                lead_id: this.props.data.lead != null && this.props.data.lead.id != null ? this.props.data.lead.id : null,
                AuthorizedToDrive: this.props.data != null && this.props.data.lead != null ? this.props.data.lead.authorizedToDrive : 0,
                postalCode: this.props.data != null && this.props.data.lead != null && this.props.data.lead.postalCode != null ? this.props.data.lead.postalCode.trim() : this.props.data.simulatorDetailsModel != null && this.props.data.simulatorDetailsModel.postalCode ? this.props.data.simulatorDetailsModel.postalCode.trim() : "",
                driverYoungAge: this.props.data.lead != null ? this.props.data.lead.driverYoungAge : "",
                driverMainBirthDateSpecificDate: this.props.data.lead != null ? this.props.data.lead.driverMainBirthDateSpecificDate : false,
                driverYoungBirthDateSpecificDate: this.props.data.lead != null ? this.props.data.lead.driverYoungBirthDateSpecificDate : false,
                driverMainSeniorityDateSpecificDate: this.props.data.lead != null ? this.props.data.lead.driverMainSeniorityDateSpecificDate : false,
                driverYoungSeniorityDateSpecificDate: this.props.data.lead != null ? this.props.data.lead.driverYoungSeniorityDateSpecificDate : false,
                driverYoungBirthDate: this.props.data.lead != null ? this.props.data.lead.driverYoungBirthDate : "",
                driverMainBirthDate: this.props.data.lead != null ? this.props.data.lead.driverMainBirthDate : "",
                driverYoungSeniority: this.props.data.lead != null ? this.props.data.lead.driverYoungSeniority : "",
                driverYoungSeniorityDate: this.props.data.lead != null ? this.props.data.lead.driverYoungSeniorityDate : "",
                driverYoungGender: this.props.data.lead != null ? this.props.data.lead.driverYoungGender : null,
                driverYoungMaritalStatus: this.props.data.lead != null ? this.props.data.lead.driverYoungMaritalStatus : null,
                driverMainAge: this.props.data.lead != null ? this.props.data.lead.driverMainAge : "",
                driverMainSeniority: this.props.data.lead != null ? this.props.data.lead.driverMainSeniority : "",
                driverMainSeniorityDate: this.props.data.lead != null ? this.props.data.lead.driverMainSeniorityDate : "",
                driverMainGender: this.props.data.lead != null ? this.props.data.lead.driverMainGender : null,
                driverMainMaritalStatus: this.props.data.lead != null ? this.props.data.lead.driverMainMaritalStatus : null,
                esp: this.props.data.lead != null && this.props.data.lead.vehicle != null && this.props.data.lead.vehicle.esp,
                fcw: this.props.data.lead != null && this.props.data.lead.vehicle != null && this.props.data.lead.vehicle.fcw,
                ldw: this.props.data.lead != null && this.props.data.lead.vehicle != null && this.props.data.lead.vehicle.ldw,
                licenseNumber: this.props.data.lead != null && this.props.data.lead.vehicle != null ? this.props.data.lead.vehicle.licenseNumber : "",
                modelCode: this.props.data.lead != null && this.props.data.lead.vehicle != null ? this.props.data.lead.vehicle.modelCode : "",
                //automaticInd: this.props.data.lead!=null && this.props.data.lead.vehicle!=null && this.props.data.lead.vehicle.automaticInd,//automaticInd,
                carYear: this.props.data.lead != null && this.props.data.lead.vehicle != null ? this.props.data.lead.vehicle.carYear
                    : new Date().getMonth() == 11 ? parseInt(this.state.CarYear[0]) : parseInt(this.state.CarYear[1]),
                entryToRoadDate: this.props.data.lead != null && this.props.data.lead.vehicle != null && this.props.data.lead.vehicle.entryToRoadDate != null ? this.props.data.lead.vehicle.entryToRoadDate : null,
                manufacturer: this.props.data.lead != null && this.props.data.lead.vehicle != null && this.props.data.lead.vehicle.manufacturer != null ? this.props.data.lead.vehicle.manufacturer.name : "",
                vehicleModel: this.props.data.lead != null && this.props.data.lead.vehicle != null && this.props.data.lead.vehicle.vehicleModel != null ? this.props.data.lead.vehicle.vehicleModel.name : "",
                vehicleSubModel: this.props.data.lead != null && this.props.data.lead.vehicle != null && this.props.data.lead.vehicle.vehicleSubModel != null ? this.props.data.lead.vehicle.vehicleSubModel.name : "",
                manufacturerId: this.props.data.lead != null && this.props.data.lead.vehicle != null && this.props.data.lead.vehicle.manufacturer != null ? this.props.data.lead.vehicle.manufacturer.id : "",
                vehicleModelId: this.props.data.lead != null && this.props.data.lead.vehicle != null && this.props.data.lead.vehicle.vehicleModel != null ? this.props.data.lead.vehicle.vehicleModel.id : "",
                vehicleSubModelId: this.props.data.lead != null && this.props.data.lead.vehicle != null && this.props.data.lead.vehicle.vehicleSubModel != null ? this.props.data.lead.vehicle.vehicleSubModel.id : "",
                passedTypeOfInsurance1: this.props.data != null && this.props.data.lead != null ? this.props.data.lead.passedTypeOfInsurance1 : null,
                sueNumber1: this.props.data.lead != null ? this.props.data.lead.sueNumber1 : "",
                passedTypeOfInsurance2: this.props.data != null && this.props.data.lead != null ? this.props.data.lead.passedTypeOfInsurance2 : null,
                sueNumber2: this.props.data.lead != null ? this.props.data.lead.sueNumber2 : "",
                passedTypeOfInsurance3: this.props.data != null && this.props.data.lead != null ? this.props.data.lead.passedTypeOfInsurance3 : null,
                sueNumber3: this.props.data.lead != null ? this.props.data.lead.sueNumber3 : "",
                passedTypeOfInsurance4: this.props.data != null && this.props.data.lead != null ? this.props.data.lead.passedTypeOfInsurance4 : null,
                sueNumber4: this.props.data.lead != null ? this.props.data.lead.sueNumber4 : "",
                sueBody: this.props.data.lead != null ? this.props.data.lead.bodyClaimsAmount : "",
                bodyClaimsAmount: this.props.data.lead != null ? this.props.data.lead.bodyClaimsAmount : "",
                revocationsAmount: this.props.data.lead != null ? this.props.data.lead.revocationsAmount : "",
                noInsurance: this.props.data.lead != null ? this.props.data.lead.noInsurance : "",
                vehicleOwnership: this.props.data != null && this.props.data.lead != null ? this.props.data.lead.vehicleOwnership : null,
                impairmentDeductible: this.props.data != null && this.props.data.lead != null ? this.props.data.lead.impairmentDeductible : null,
                renovationAgentsOffice: this.props.data != null && this.props.data.lead != null ? this.props.data.lead.renovationAgentsOffice : null,
                renovationCompany: this.props.data != null && this.props.data.lead != null ? this.props.data.lead.renovationCompany : null,
                mainVehicle: this.props.data.lead != null && this.props.data.lead.mainVehicle != null && this.props.data.lead.mainVehicle,
                autodirection: this.props.data.lead != null && this.props.data.lead.mainVehicle != null && this.props.data.lead.autodirection,
                driveInShabbat: /*this.props.data.lead!=null && this.props.data.lead.mainVehicle!=null && this.props.data.lead.driveInShabbat*/true,
                newForOld: this.props.data.lead != null && this.props.data.lead.mainVehicle != null && this.props.data.lead.newForOld,
                firstName: this.props.data.lead != null ? this.props.data.lead.firstName : "",
                phoneNumber1: this.props.data.lead != null ? this.props.data.lead.phoneNumber1 : "",
                cityId: this.props.data.lead != null && this.props.data.lead.cityId != null ? this.props.data.lead.cityId : null,
                city: this.props.data.lead != null ? this.props.data.lead.city : null,
                address: this.props.data.lead != null ? this.props.data.lead.address : undefined,
                street: this.props.data.lead != null ? this.props.data.lead.street : undefined,
            };
            if (simData.startDateSelectValue == 1 || this.isToday(simData.lead_startDate)) {
                simData.lead_startDate = new Date();

                if (simData.driverYoungBirthDateSpecificDate != true) {
                    if (!simData.driverYoungBirthDate) {
                        simData.driverYoungAge = 24;
                    }
                    simData.driverYoungBirthDate = this.calculateDateFromAge(simData.driverYoungAge, simData.lead_startDate);
                }
                if (simData.driverMainBirthDateSpecificDate != true) {
                    if (!simData.driverMainBirthDate) {
                        simData.driverMainAge = 24;
                    }
                    simData.driverMainBirthDate = this.calculateDateFromAge(simData.driverMainAge, simData.lead_startDate);
                }
                if (simData.driverYoungSeniorityDateSpecificDate != true) {
                    if (!simData.driverYoungSeniorityDate) {
                        simData.driverYoungSeniority = 6;
                    }
                    simData.driverYoungSeniorityDate = this.calculateDateFromAge(simData.driverYoungSeniority, simData.lead_startDate);
                }
                if (simData.driverMainSeniorityDateSpecificDate != true) {
                    if (!simData.driverMainSeniorityDate) {
                        simData.driverMainSeniority = 6;
                    }
                    simData.driverMainSeniorityDate = this.calculateDateFromAge(simData.driverMainSeniority, simData.lead_startDate);
                }
            }
            simData.lead_endDate = this.getCalcEndDateByStartDate(simData.lead_startDate);

            console.log('simData.postalCode, simData.cityId', simData.postalCode, simData.cityId);
            if (simData.postalCode && simData.postalCode.length > 0) {

                var address = await new SimulatorModel().GetAddressByPostalCode(simData.postalCode);
                simData.city = address.city;
                simData.cityId = parseInt(address.cityId);
                simData.address = address.comment;
                simData.street = address.street;
                simData.houseNumber = address.houseNumber;


            }
            await this.setState({
                simulatorData: simData
            }, async () => {
                // var simData = this.state.simulatorData;
                // if(simData.licenseNumber!=null && simData.licenseNumber.length>0)
                //     await this.getVehicleDetails(simData.licenseNumber);
                // else if(simData.modelCode!=null && simData.modelCode.length>0){

                //     await this.getModelDataByCode(simData.modelCode,simData.licenseNumber);
                // }


                const vehicle: VehicleDetailsData = new VehicleDetailsData();
                var simData = this.state.simulatorData;
                vehicle.modelCode = simData.modelCode;
                vehicle.manufacturerId = simData.manufacturerId;
                vehicle.vehicleModelId = simData.vehicleModelId;
                vehicle.vehicleSubModelId = simData.vehicleSubModelId;
                vehicle.carYear = simData.carYear
                await this.setState({ Vehicle: vehicle });


                await this.setState({ showVehicleDetails: true });
            });

            await this.setState({ loading: false });


        }


    };

    isToday(date: Date): boolean {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const check = new Date(date);
        check.setHours(0, 0, 0, 0);

        return check.getTime() === today.getTime();
    }


    onCityChange = (city: string) => {
        let stateData = this.state.simulatorData;
        const cities = this.state.citiesAutocomplete.filter(
            (m: any) => {
                return m.text != null && m.text.indexOf(city) > -1
            }
        );
        this.setState({
            citiesAutocomplete: cities
        });
        if (stateData) {
            stateData.cityText = city;
            this.setState({ simulatorData: stateData });

        }
    }

    onCitySelect = async (city: string) => {
        //console.log('onCitySelect', city)
        let stateData = this.state.simulatorData;
        if (stateData) {
            stateData.cityId = await new SimulatorModel().simulatorGetCityIdByCity(city);
            stateData.city = city;
            this.setState({ simulatorData: stateData });
        }
    }

    loadModelCode = async (search: string) => {
        if (search && search.length >= 3) {
            this.setState({
                ModelcodeAutocomplete: await new SimulatorModel().getModelCode(search),


            });
        }

        this.setStateData("modelCode", search);

        //this.clearModelVehicleDataForModelCode();
    }

    connectVehicle = async (vehicleSubmodelId?: string) => {

        if (vehicleSubmodelId) {
            var simData = this.state.simulatorData;
            const generalModel: GeneralDataModel = new GeneralDataModel();
            let data = await generalModel.getVehicleInfoGetVehicleSubModelsById(vehicleSubmodelId);
            simData.vehicleModelId = vehicleSubmodelId;
            simData.manufacturer = data.vehicleModel.manufacturer.name;
            simData.vehicleModel = data.vehicleModel.name;
            simData.vehicleSubModel = data.name;
            simData.manufacturerId = data.vehicleModel.manufacturer.id;
            simData.vehicleModelId = data.vehicleModel.id;
            simData.vehicleSubModelId = data.id;


            this.setState({ simulatorData: simData });
            this.setState({ missingVehicleDetails: false });
            this.setState({ showVehicleDetails: false });

            this.closePopup();
        }
    }


    selectModelCode = async (id: string) => {


        console.log("auto fire select");


        if (id != null && id.length > 0) {


            if (id) {
                var data = await new SimulatorModel().getVehicleDetails(id);

                // this.setStateData("manufacturerId",data.manufacturer.val);
                // this.setStateData("manufacturer",data.manufacturer.label);
                // this.setStateData("vehicleModelId",data.vehicleModel.val);
                // this.setStateData("vehicleModel",data.vehicleModel.label);
                //this.setStateData("vehicleSubModelId", null);

                this.setStateData("modelCode", data.vehicleSubModel.code);
                //Added on February 8, 2026 to solve Levi Yitschak’s error.
                this.getModelDataByCode(data.vehicleSubModel.code, "");

                // const modelCodes: any[] = this.state.ModelcodeAutocomplete as any[];
                // const modelCode = modelCodes.find(model => model.value == id);

                // if (modelCode) {
                //     const code = modelCode.text.split(' - ')[0];
                //     const data = await this.getModelDataByCode(code, "");
                //     // if (data) {    
                //     //     this.setStateData("carYear", data.carYear);
                //     //     this.setStateData("entryToRoadDate", data.entryToRoad);      
                //     //     // this.setState({Lead: lead});
                //     // }
                // }
            } else {
                this.setStateData("modelCode", null);
            }
            // this.setState({
            //     codeModelLoading: false
            // })
        }
        else {
            this.setStateData("modelCode", "");
            console.log("lastmodelCode remove");
            this.setState({ lastmodelCode: "" });
            this.setState({ ModelcodeAutocomplete: [] });
            this.clearModelVehicleDataForModelCode();
        }

    }


    getModelDataByCode = async (code: string, licenseNumber: string) => {
        console.log("auto fire blur");

        // while (this.insideGetModelDataByCode) {}
        // this.insideGetModelDataByCode = true;
        // if (this.state.simulatorData.vehicleSubModelId != null && this.state.simulatorData.vehicleSubModelId != "" && this.state.simulatorData.vehicleSubModelId != "00000000-0000-0000-0000-000000000000")
        //     return;
        // if modelcode came from license number.
        if (code.length > 4 && this.state.lastmodelCode != code) {
            this.setState({
                codeModelLoading: true
            });
            console.log("lastmodelCode add");
            this.setState({
                lastmodelCode: code
            })

            // await this.setState({
            //     vehicleDetailsError: "",
            //     entryToRoadDateError: "",
            //     manufacturerError: "",
            //     vehicleModelError: "",
            //     vehicleSubModelError: ""
            // });

            this.clearModelVehicleDataForModelCode();
            let data: any = null;
            const vehicle: VehicleDetailsData = new VehicleDetailsData();
            try {
                data = await new SimulatorModel().getModelDetailsByModelCode(code, licenseNumber);
                const simulatorData = this.state.simulatorData;

                if (data != null) {


                    if (data.LeviItzhak != null) {
                        vehicle.modelCode = code;

                        simulatorData.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
                        if (licenseNumber == null || licenseNumber.length == 0) {
                            simulatorData.carYear = data.LeviItzhak.carYear;
                            vehicle.carYear = data.LeviItzhak.carYear;
                            simulatorData.entryToRoadDate = data.LeviItzhak.entryToRoad;
                        }
                        if (data.LeviItzhak.manufacturer != null) {
                            simulatorData.manufacturerId = data.LeviItzhak.manufacturer.val
                            simulatorData.manufacturer = data.LeviItzhak.manufacturer.label;
                            vehicle.manufacturerId = data.LeviItzhak.manufacturer.val;

                        }
                        if (data.LeviItzhak.vehicleModel != null) {

                            simulatorData.vehicleModelId = data.LeviItzhak.vehicleModel.val
                            simulatorData.vehicleModel = data.LeviItzhak.vehicleModel.label;

                            vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val;
                        }

                        if (data.LeviItzhak.vehicleSubModel != null) {

                            simulatorData.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val
                            simulatorData.vehicleSubModel = data.LeviItzhak.vehicleSubModel.label;
                            simulatorData.modelCode = data.LeviItzhak.vehicleSubModel.code;

                            vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;

                            vehicle.tozeretCd = data.LeviItzhak.tozeretCd;
                            vehicle.degemCd = data.LeviItzhak.degemCd;



                        }
                        simulatorData.esp = data.LeviItzhak.esp;
                        simulatorData.fcw = data.LeviItzhak.fcw;
                        simulatorData.ldw = data.LeviItzhak.ldw;


                        if (data.LeviItzhak.error != null && data.LeviItzhak.error.code && (data.LeviItzhak.error.code > 0)) {
                            await this.setState({ missingVehicleDetails: true });
                            await this.setState({ showVehicleDetails: true });


                        }
                        else {
                            await this.setState({ missingVehicleDetails: false });
                            await this.setState({ showVehicleDetails: true });
                        }

                    }
                    simulatorData.licenseNumberLoading = false;
                }

                //simulatorData.licenseNumber = licenseNumber;
                await this.setState({ simulatorData: simulatorData });
                await this.setState({ Vehicle: vehicle });

                this.setState({
                    codeModelLoading: false
                })

            } catch (error) {

            }
            return data;

        }
        //this.insideGetModelDataByCode = false;
    }


    loadManufacturer = async (search: string) => {
        const dataAll = await this.state.ManufacturerAll;

        this.setState({
            ManufacturerAutocomplete: dataAll.filter(m => m.label != null && m.label.indexOf(search) > -1)

        });

        this.setStateData("manufacturer", search);
    }

    selectManufacturer = async (event: any) => {
        var id = event.currentTarget.id;
        var value = event.currentTarget.innerHTML;
        var data = await new SimulatorModel().getVehicleModelByManufactureOrSearch(undefined, id);

        this.setState({
            VehicleModelAll: data

        });

        this.setStateData("manufacturer", value);
        this.setStateData("vehicleModel", "");
        this.setStateData("vehicleModelId", "");
        this.setStateData("vehicleSubModel", "");
        this.setStateData("vehicleSubModelId", "");
        this.setStateData("modelCode", "");

        this.setState({
            VehicleModelAutocomplete: data

        });
    }

    loadVehicleModel = async (search: string) => {

        const dataAll = this.state.VehicleModelAll;

        this.setState({
            VehicleModelAutocomplete: dataAll.filter(m => m.label != null && m.label.indexOf(search) > -1)

        });

        this.setStateData("vehicleModel", search);
    }

    selectVehicleModel = async (event: any) => {
        var id = event.currentTarget.id;
        var value = event.currentTarget.innerHTML;
        var data = await new SimulatorModel().getVehicleSubModelByVehicleModelOrSearch(undefined, id);

        this.setState({
            VehicleSubModelAll: data
        });

        this.setStateData("vehicleModel", value);
        this.setStateData("vehicleModelId", id);
        this.setStateData("vehicleSubModel", "");
        this.setStateData("vehicleSubModelId", "");
        this.setStateData("modelCode", "");

        this.setState({
            VehicleSubModelAutocomplete: data

        });
    }

    loadVehicleSubModel = async (search: string) => {

        const dataAll = this.state.VehicleSubModelAll;

        this.setState({
            ManufacturerAutocomplete: dataAll.filter(m => m.label != null && m.label.indexOf(search) > -1)

        });

        this.setStateData("vehicleSubModel", search);
    }

    selectVehicleSubModel = async (event: any) => {
        this.selectModelCode(event);
    }

    getVehicleDetailsKeyPress = async (event: any) => {
        if (event.key === 'Enter') {
            this.getVehicleDetails(event);
        }
    }

    clearVehicleData = async () => {

        const simulatorData = this.state.simulatorData;
        simulatorData.modelCode = "";
        simulatorData.automaticInd = true;
        simulatorData.carYear = new Date().getMonth() == 11 ? parseInt(this.state.CarYear[0]) : parseInt(this.state.CarYear[1]);
        simulatorData.entryToRoadDate = null;
        simulatorData.manufacturer = "";
        simulatorData.vehicleModel = "";
        simulatorData.vehicleSubModel = "";
        simulatorData.manufacturerId = null;
        simulatorData.vehicleModelId = null;
        simulatorData.vehicleSubModelId = null;
        simulatorData.esp = false;
        simulatorData.fcw = false;
        simulatorData.ldw = false;
        const vehicleData = this.state.Vehicle;
        if (vehicleData != null) {
            vehicleData.manufacturerId = "";
            vehicleData.vehicleModelId = "";
            vehicleData.vehicleSubModelId = "";
            vehicleData.modelCode = "";
            vehicleData.tozeretCd = undefined;
            vehicleData.degemCd = undefined;
        }
        await this.setState({ simulatorData: simulatorData });
        await this.setState({ Vehicle: vehicleData });
        await this.setState({ ModelcodeAutocomplete: [] });

    }

    clearModelVehicleDataForLicenseNumber = async () => {
        const simulatorData = {
            ...this.state.simulatorData,
            automaticInd: true,
            manufacturer: "",
            vehicleModel: "",
            vehicleSubModel: "",
            manufacturerId: null,
            vehicleModelId: null,
            vehicleSubModelId: null,
            modelCode: "",
            esp: false,
            fcw: false,
            ldw: false
        };

        const vehicleData = this.state.Vehicle
            ? {
                ...this.state.Vehicle,
                manufacturerId: "",
                vehicleModelId: "",
                vehicleSubModelId: "",
                modelCode: "",
                tozeretCd: undefined,
                degemCd: undefined
            }
            : null;

        this.setState({
            simulatorData,
            Vehicle: vehicleData,
            vehicleDetailsError: "",
            entryToRoadDateError: "",
            manufacturerError: "",
            vehicleModelError: "",
            vehicleSubModelError: "",
            lastmodelCode: ""
        });
    };

    clearModelVehicleDataForModelCode = async () => {
        const simulatorData = {
            ...this.state.simulatorData,
            automaticInd: true,
            manufacturer: "",
            vehicleModel: "",
            vehicleSubModel: "",
            manufacturerId: null,
            vehicleModelId: null,
            vehicleSubModelId: null,
            esp: false,
            fcw: false,
            ldw: false
        };

        const vehicleData = this.state.Vehicle
            ? {
                ...this.state.Vehicle,
                manufacturerId: "",
                vehicleModelId: "",
                vehicleSubModelId: "",
                modelCode: "",
                tozeretCd: undefined,
                degemCd: undefined
            }
            : null;

        this.setState({
            simulatorData,
            Vehicle: vehicleData,
            vehicleDetailsError: "",
            entryToRoadDateError: "",
            manufacturerError: "",
            vehicleModelError: "",
            vehicleSubModelError: ""

        });
    };


    licenseNumberChange = async (event: any) => {
        this.setStateInputData("licenseNumber", event);
        // this.clearModelVehicleDataForLicenseNumber();

    }

    getVehicleDetails = async (event: any) => {
        var licenseNumber = "";
        if (typeof event === 'string') {
            licenseNumber = event;
        }

        if (licenseNumber == "")
            licenseNumber = event.currentTarget.value.trim();

        // if (licenseNumber.length > 0) {
        //     await this.setState({
        //         vehicleDetailsError: "",
        //         entryToRoadDateError: "",
        //         manufacturerError: "",
        //         vehicleModelError: "",
        //         vehicleSubModelError: ""
        //     });

        // }

        if (licenseNumber.length > 0 && this.state.lastLicense != licenseNumber) {
            await this.setState({ lastLicense: licenseNumber });

            this.clearVehicleData();

            try {
                this.setStateData("licenseNumberLoading", true);
                var data = await new SimulatorModel().getVehicleDetailsByLicenseNumber(licenseNumber);

                //console.log('getVehicleDetails data', data);

                const simulatorData = this.state.simulatorData;



                if (data != null) {
                    const vehicle: VehicleDetailsData = new VehicleDetailsData();
                    //this.setStateData("esp", false);
                    //this.setStateData("fcw", false);
                    //this.setStateData("ldw", false);
                    if (data.LeviItzhak != null) {
                        simulatorData.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
                        simulatorData.carYear = data.LeviItzhak.carYear;
                        vehicle.carYear = data.LeviItzhak.carYear;
                        simulatorData.entryToRoadDate = data.LeviItzhak.entryToRoad;
                        if (data.LeviItzhak.manufacturer != null) {
                            // this.setStateData("manufacturerId",data.LeviItzhak.manufacturer.val);
                            // this.setStateData("manufacturer",data.LeviItzhak.manufacturer.label);


                            simulatorData.manufacturerId = data.LeviItzhak.manufacturer.val
                            simulatorData.manufacturer = data.LeviItzhak.manufacturer.label;
                            vehicle.manufacturerId = data.LeviItzhak.manufacturer.val;

                        }
                        if (data.LeviItzhak.vehicleModel != null) {
                            //     this.setStateData("vehicleModelId",data.LeviItzhak.vehicleModel.val);
                            // this.setStateData("vehicleModel",data.LeviItzhak.vehicleModel.label);

                            simulatorData.vehicleModelId = data.LeviItzhak.vehicleModel.val
                            simulatorData.vehicleModel = data.LeviItzhak.vehicleModel.label;

                            vehicle.vehicleModelId = data.LeviItzhak.vehicleModel.val;
                        }

                        if (data.LeviItzhak.vehicleSubModel != null) {
                            // 
                            // this.setStateData("vehicleSubModelId",data.LeviItzhak.vehicleSubModel.val);
                            // this.setStateData("vehicleSubModel",data.LeviItzhak.vehicleSubModel.label);

                            // this.setStateData("modelCode", data.LeviItzhak.vehicleSubModel.code);

                            simulatorData.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val
                            simulatorData.vehicleSubModel = data.LeviItzhak.vehicleSubModel.label;
                            simulatorData.modelCode = data.LeviItzhak.vehicleSubModel.code;

                            vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;
                            vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;
                            vehicle.tozeretCd = data.LeviItzhak.tozeretCd;
                            vehicle.degemCd = data.LeviItzhak.degemCd;

                            await this.setState({ Vehicle: vehicle })
                            if (simulatorData.modelCode != null && simulatorData.modelCode.length > 0) {
                                this.setState({ lastmodelCode: simulatorData.modelCode });
                            }
                            // if(data.LeviItzhak.entryToRoad!=undefined)
                            //     this.setStateData("entryToRoadDate", data.LeviItzhak.entryToRoad);
                        }
                        // this.setStateData("esp", data.LeviItzhak.esp);
                        // this.setStateData("fcw", data.LeviItzhak.fcw);
                        // this.setStateData("ldw", data.LeviItzhak.ldw);


                        simulatorData.esp = data.LeviItzhak.esp;
                        simulatorData.fcw = data.LeviItzhak.fcw;
                        simulatorData.ldw = data.LeviItzhak.ldw;


                        if (data.LeviItzhak.error != null && data.LeviItzhak.error.code && (data.LeviItzhak.error.code > 0)) {
                            await this.setState({ missingVehicleDetails: true });
                            await this.setState({ showVehicleDetails: true });


                        }
                        else {
                            ///////////////////////////////////////////
                            await this.setState({ missingVehicleDetails: false });
                            await this.setState({ showVehicleDetails: true });
                        }

                        // manufacturer
                        // vehicleModel
                        // vehicleSubModel
                        // esp
                        // fcw
                        // ldw
                        /*
                
                        
                i
                        
        */
                    }
                    simulatorData.licenseNumberLoading = false;
                    //await this.setStateData("licenseNumberLoading", false);
                }

                simulatorData.licenseNumber = licenseNumber;
                //await this.setStateData("licenseNumber", licenseNumber);


                await this.setState({ simulatorData: simulatorData });
            } catch (error) {
                await this.setState({ vehicleDetailsError: "מספר הרכב או פרטי הרכב אינם תקינים" });

                console.log(error);
            }
        }
        else {
            //this.clearVehicleData();
        }
    }


    setYoungGender = async (name: string, value: any) => {
        //console.log("setStateData", name, value);

        if (this.state.simulatorData != null && this.state.simulatorData.AuthorizedToDrive == "2" && this.state.clalMainFill == false) {
            this.setStateData("driverMainGender", value);
        }
        const data = this.state.simulatorData;
        data[name] = value;
        await this.setState({ simulatorData: data });

    }

    setYoungMaritalStatus = async (name: string, value: any) => {
        //console.log("setStateData", name, value);

        if (this.state.simulatorData != null && this.state.simulatorData.AuthorizedToDrive == "2" && this.state.clalMainFill == false) {
            this.setStateData("driverMainMaritalStatus", value);
        }
        const data = this.state.simulatorData;
        data[name] = value;
        await this.setState({ simulatorData: data });

    }



    setStateData = async (name: string, value: any) => {


        console.log("setStateData", name, value, typeof value);

        const data = this.state.simulatorData;
        data[name] = value;
        await this.setState({ simulatorData: data });
        if (name == "lead_startDate") {
            let _data = this.state.simulatorData;
            _data = this.calcAges(_data);
            await this.setState({ simulatorData: data });

        }


    }

    setAuthorizedToDrive = async (name: string, value: any) => {
        console.log("setStateData", name, value);
        let data = this.state.simulatorData;
        data[name] = value;
        data.driverYoungAge = 24;
        this.setDriverAgeOrSeniority("driverYoungAge", 24);
        data.driverYoungSeniority = 6;
        this.setDriverAgeOrSeniority("driverYoungSeniority", 6);
        data.driverMainAge = 24;
        this.setDriverAgeOrSeniority("driverMainAge", 24);
        data.driverMainSeniority = 6;
        this.setDriverAgeOrSeniority("driverMainSeniority", 6);




        data = await this.calcAges(data);
        await this.setState({
            simulatorData: data,
            mainAgeError: "",
            youngAgeError: "",
            seniorityMainError: "",
            seniorityYoungError: ""
        });

        // this.agesValidations();

    }

    setCheckboxStateData = (name: string, event: any) => {
        const data = this.state.simulatorData;
        data[name] = event.currentTarget.checked;
        this.setState({ simulatorData: data });

    }
    setNoInsurance = (name: string, event: any) => {
        this.setCheckboxStateData(name, event);
        if (event.currentTarget.checked) {
            this.setStateData("passedTypeOfInsurance1", "2");
            this.setStateData("passedTypeOfInsurance2", "2");
            this.setStateData("passedTypeOfInsurance3", "2");
            this.setStateData("passedTypeOfInsurance4", "2");

            this.setStateData("sueNumber1", "0");
            this.setStateData("sueNumber2", "0");
            this.setStateData("sueNumber3", "0");
            this.setStateData("sueNumber4", "0");

        }

    }

    setStateInputData = (name: string, event: any) => {
        const data = this.state.simulatorData;
        data[name] = name === 'bodyClaimsAmount' ? Number(event.currentTarget.value) : event.currentTarget.value.replace(/\s{2,}/g, " ").trimStart();
        if (name === "licenseNumber" && data[name].length > 0) {
            this.setState({ vehicleDetailsError: "" });
        }
        this.setState({ simulatorData: data });
    }

    setPostalCode = async (name: string, event: any) => {

        const data = this.state.simulatorData;
        data["postalCode"] = event.currentTarget.value.trim();
        this.setState({ simulatorData: data });

    }

    loadPostalCode = async (name: string, event: any) => {
        //  
        var val = event.currentTarget.value;
        const data = await this.state.simulatorData;
        if (val == null || val.length == 6 || val.length < 5 || val.length > 7) {
            this.setState({ postalCodeSpiner: false });
            this.setState({ PostalcodeError: "יש להקליד מיקוד  תקין בן 7 ספרות" });
            return;
        } else if (val.length > 6) {
            this.setState({ PostalcodeError: "" });
        }


        data.cityId = 0;
        data.city = "";
        data.address = "";
        await this.setState({ simulatorData: data });
        //data.address = "";
        data.postalCode = val;
        //var valid = this.postalcodeValidation(data);
        if (true) {

            await this.setState({ postalCodeSpiner: true });

            var address = await new SimulatorModel().GetAddressByPostalCode(val);
            console.log('data-loadPostalCode-result', address);
            if (address && address.cityId == null && (data.city == null || data.city == 0)) {
                this.openAddressPopup();

            }
            else if (address && address.cityId == null && data.city != null && data.city > 0) {

                await this.setState({ postalCodeSpiner: false });
                this.postalcodeValidation(data);
                return;
            }
            else if (address && address.cityId != null && address.cityId.toString().length > 0) {
                data.cityId = parseInt(address.cityId);
                data.city = address.city;
                data.address = address.comment;
                data.street = address.street;
                data.houseNumber = address.houseNumber;

            }
            console.log('data-loadPostalCode', data, data.address);

            this.setState({ simulatorData: data });
            this.setState({ postalCodeSpiner: false });

        }




    }

    setDriverAgeOrSeniority = (name: string, value: number) => {
        const data = this.state.simulatorData;
        var startDate = data.lead_startDate;


        if (value >= 0) {
            // 
            var year = startDate.getFullYear() - value;

            var dateName = "";
            var specificName = "";
            var specificName2 = "";
            var dateName2 = "";
            var dateName3 = "";

            switch (name) {
                case "driverYoungAge": dateName = "driverYoungBirthDate"; dateName2 = "driverMainBirthDate"; dateName3 = "driverMainAge"; specificName = "driverYoungBirthDateSpecificDate"; specificName2 = "driverMainBirthDateSpecificDate"; break;
                case "driverMainAge": dateName = "driverMainBirthDate"; dateName2 = "driverYoungBirthDate"; dateName3 = "driverYoungAge"; specificName = "driverMainBirthDateSpecificDate"; specificName2 = "driverYoungBirthDateSpecificDate"; break;
                case "driverYoungSeniority": dateName = "driverYoungSeniorityDate"; dateName2 = "driverMainSeniorityDate"; dateName3 = "driverMainSeniority"; specificName = "driverYoungSeniorityDateSpecificDate"; specificName2 = "driverMainSeniorityDateSpecificDate"; break;
                case "driverMainSeniority": dateName = "driverMainSeniorityDate"; dateName2 = "driverYoungSeniorityDate"; dateName3 = "driverYoungSeniority"; specificName = "driverMainSeniorityDateSpecificDate"; specificName2 = "driverYoungSeniorityDateSpecificDate"; break;
            }




            var curDate = startDate;//new Date();
            console.log('setDriverAge year', year)

            this.setStateData(dateName, new Date(year, curDate.getMonth(), curDate.getDate()));
            this.setStateData(specificName, false);

            if (this.state.simulatorData != null && this.state.simulatorData.AuthorizedToDrive == "2" && this.state.clalMainFill == false && dateName2 != "") {
                this.setStateData(dateName2, new Date(year, curDate.getMonth(), curDate.getDate()));
                this.setStateData(specificName2, false);

                this.setStateData(dateName3, value);
            }
            if (this.state.simulatorData != null && this.state.simulatorData.AuthorizedToDrive == "0" && dateName2 != "") {
                this.setStateData(dateName2, new Date(year, curDate.getMonth(), curDate.getDate()));
                this.setStateData(specificName2, false);

                this.setStateData(dateName3, value);
            }
        }
    }


    youngBetweenMainAgesValidation = (data: SimulatorData) => {
        let valid = true;
        if (Number(data.driverYoungAge) > Number(data.driverMainAge)) {
            this.setState({ mainAgeError: "נהג עיקרי צעיר יותר מנהג צעיר" });
            valid = false;
        }
        else if (Number(data.driverMainAge) < 83 && Number(data.driverYoungAge) < 83) { // to avoid false positive when both ages are over 83
            this.setState({ mainAgeError: "" });
        }

        // if (Number(data.driverYoungSeniority) > Number(data.driverMainSeniority)) {
        //     console.log('data.driverYoungSeniority > data.driverMainSeniority', data.driverYoungSeniority > data.driverMainSeniority, data.driverYoungSeniority, data.driverMainSeniority);
        //     console.log('invalid seniority');
        //     this.setState({ seniorityMainError: "וותק הנהג העיקרי נמוך מוותק הנהג הצעיר" });
        //     valid = false;
        // }
        // else {
        //     console.log('valid seniority 3');
        //     this.setState({ seniorityMainError: "" });
        // }
        return valid;
    }

    setDriverAge = async (name: string, event: any) => {
        this.setStateInputData(name, event);

        var age = parseInt(event.currentTarget.value);
        await this.setDriverAgeOrSeniority(name, age);


        //validations
        // this.agesValidations()
    }

    // agesValidations() {
    //     var simData = this.state.simulatorData;
    //     this.youngBetweenMainAgesValidation(simData);
    //     this.youngAgeValidation(simData);
    //     this.mainAgeValidation(simData);
    //     this.mainSeniorityValidation(simData);
    //     this.youngSeniorityValidation(simData);
    // }

    setDriverDate = async (name: string, value: any) => {
        var simData = this.state.simulatorData;
        //     var startDate = simData.lead_startDate.setHours(0, 0, 0, 0);
        var age = calculateAge(value, simData.lead_startDate);
        if (name == "driverYoungBirthDate") {
            this.setStateData("driverYoungAge", age);

            if (this.state.simulatorData != null && this.state.simulatorData.AuthorizedToDrive == "2" && this.state.clalMainFill == false) {
                this.setStateData("driverMainAge", age);
                this.setStateData("driverMainBirthDate", value);
                this.setStateData("driverMainBirthDateSpecificDate", true);
            }
            this.setStateData("driverYoungBirthDateSpecificDate", true);
        }
        else if (name == "driverMainBirthDate") {
            this.setStateData("driverMainAge", age);
            this.setStateData("driverMainBirthDateSpecificDate", true);

            if (this.state.simulatorData != null && this.state.simulatorData.AuthorizedToDrive == "0") {
                this.setStateData("driverYoungAge", age);
                this.setStateData("driverYoungBirthDate", value);
                this.setStateData("driverYoungBirthDateSpecificDate", true);
            }
        }
        else if (name == "driverYoungSeniorityDate") {
            this.setStateData("driverYoungSeniority", age);
            this.setStateData("driverYoungSeniorityDateSpecificDate", true);
            if (this.state.simulatorData != null && this.state.simulatorData.AuthorizedToDrive == "2" && this.state.clalMainFill == false) {
                this.setStateData("driverMainSeniority", age);
                this.setStateData("driverMainSeniorityDate", value);
                this.setStateData("driverMainSeniorityDateSpecificDate", true);
            }
        }
        else if (name == "driverMainSeniorityDate") {
            this.setStateData("driverMainSeniority", age);
            this.setStateData("driverMainSeniorityDateSpecificDate", true);

            if (this.state.simulatorData != null && this.state.simulatorData.AuthorizedToDrive == "0") {
                this.setStateData("driverYoungSeniority", age);
                this.setStateData("driverYoungSeniorityDate", value);
                this.setStateData("driverYoungSeniorityDateSpecificDate", true);
            }
        }

        await this.setStateData(name, value);
        // var simData = this.state.simulatorData;
        // this.youngBetweenMainAgesValidation(simData);

    }

    datediff = (startDate: Date, endDate: Date) => {
        if (endDate != null && startDate != null) {

            var diff = Math.abs(endDate.getTime() - startDate.getTime());
            var diffDays = Math.ceil(diff / (1000 * 3600 * 24));
            return diffDays;
        }
        return 0;
    }

    // calculateAge = (birthday: Date): number => {
    //     var simData = this.state.simulatorData;
    //     var startDate = simData.lead_startDate.setHours(0, 0, 0, 0);
    //     let timeDiff = Math.abs(startDate - birthday.getTime());
    //     return Math.floor((timeDiff / (1000 * 3600 * 24)) / 365.25);
    // }

    // calculateAge = (birthDate: Date): number => {
    //     var simData = this.state.simulatorData;
    //     var startDate = this.toStartOfDay(simData.lead_startDate);
    //     let age = startDate.getFullYear() - birthDate.getFullYear();

    //     const hasHadBirthdayThisYear =
    //         startDate.getMonth() > birthDate.getMonth() ||
    //         (startDate.getMonth() === birthDate.getMonth() &&
    //             startDate.getDate() >= birthDate.getDate());

    //     if (!hasHadBirthdayThisYear) {
    //         age--;
    //     }

    //     return age;
    // }

    // toStartOfDay = (date: Date): Date => {
    //     const d = new Date(date);
    //     d.setHours(0, 0, 0, 0);
    //     return d;
    // }


    startDateSelectChange = async (name: string, value: any) => {
        await this.setStateData(name, value);
        if (value == 3) {
            if (this.startDateRef.current != null)
                this.startDateRef.current.setOpen(true);

        }
        else if (value == 1) {
            await this.setStartDate("lead_startDate", new Date());
        }
        else if (value == 2) {
            var date = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1, 0, 0, 0, 0);
            await this.setStartDate("lead_startDate", date);
        }

        ////////////////////////////***//// */

    }


    setStartDate = async (name: string, value: any) => {
        await this.setStateData(name, value);
        this.calcEndDate();

        // this.agesValidations()
    }

    setEndDate = (name: string, value: any) => {
        this.setStateData(name, value);
    }

    calcEndDate() {
        if (this.state.simulatorData != null && this.state.simulatorData.lead_startDate) {
            var endDate = this.getCalcEndDate();
            this.setStateData("lead_endDate", endDate);

        }


    }

    getCalcEndDate = () => {
        // 
        const data = this.state.simulatorData;
        var startDate = data.lead_startDate;


        return this.getCalcEndDateByStartDate(startDate);


    }

    getCalcEndDateByStartDate = (startDate: Date) => {
        // 
        if (startDate != null) {
            var month = startDate.getMonth();
            var year = startDate.getFullYear();
            if (startDate.getDate() > 15) {
                month++;
                if (month == 13) {
                    month = 1;
                    year++;
                }

            }
            var endDate = new Date(year + 1, month, 1, 0, 0, 0, 0);
            endDate.setDate(endDate.getDate() - 1);
            return endDate;

        }
        return new Date();
    }
    calculateDateFromAge(age: number, startDate: Date): Date {
        return new Date(
            startDate.getFullYear() - age,
            startDate.getMonth(),
            startDate.getDate()
        );
    }


    calculateAgeFromDate(dateOfBirth: Date): number {
        const today = new Date();
        const birthDate = new Date(dateOfBirth);

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        // If the birth month is greater than the current month OR
        // If the birth month equals the current month but the birth day is greater than the current day,
        // then decrement the age by 1
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }
    closePopup() {
        this.setState({ ShowVehiclePopup: false });
    }
    closeAddressPopup() {
        this.setState({ ShowAddressPopup: false });
    }

    async GetPostalCode(postalCode: string, address: CustomerAddress | null) {
        //
        const data = this.state.simulatorData;

        if ((postalCode == null || postalCode.trim().length == 0) && address != null) {

            data.city = address.city;
            data.address = (address.street ? address.street : "") + (address.houseNumber ? " " + address.houseNumber : "");
            data.cityId = await new SimulatorModel().simulatorGetCityIdByCity(address.city);

            data.postalCode = "";
            this.setState({ PostalcodeError: "לא אותר מיקוד." });

            this.closeAddressPopup();

        }
        else if ((postalCode == null || postalCode.trim().length == 0)) {
            this.setState({ PostalcodeError: "לא אותר מיקוד." });
            this.closeAddressPopup();

        }
        else {
            this.setState({ PostalcodeError: "" });

            data.postalCode = postalCode.trim();
            if (address) {
                // 
                data.city = address.city;
                data.address = (address.city ? address.city : "") + (address.street ? " " + address.street : "") + (address.houseNumber ? " " + address.houseNumber : "");
                data.street = address.street;
                data.houseNumber = address.houseNumber;
                data.mailbox = address.mailbox;
                var addr = await new SimulatorModel().simulatorGetCityIdByCity(address.city);
                if (addr == null) {
                    this.setState({ PostalcodeError: "לא נמצאה עיר" })
                }
                else {
                    data.cityId = addr;
                    this.setState({ PostalcodeError: "" })
                }
            }



            // this.setState({ simulatorData: data });
            // var addr = await new SimulatorModel().GetAddressByPostalCode(postalCode);
            // if (addr.cityId == null) {
            //     this.setState({ PostalcodeError: "לא נמצאה עיר" })
            // }
            // else {
            //     data.cityId = addr.cityId;
            //     data.city = addr.city;
            //     data.address = addr.address;
            // }



            await this.setState({ simulatorData: data });


            this.closeAddressPopup();

        }

        this.closeAddressPopup();
        this.postalcodeValidation(data);

    }

    async GetAddress(address: CustomerAddress) {
        // if (address.city)
        //     this.onCitySelect(address.city);

        // var simMode = this.state.simulatorData;
        // simMode.address = (address.street? address.street:"") +(address.houseNumber?" "+address.houseNumber:"");

        // await this.setState({simulatorData:simMode});

    }

    async openAddressPopup() {
        ///? clear postal data?
        // var simMode = this.state.simulatorData;
        // simMode.postalCode = "";
        //await this.setState({simulatorData:simMode});
        this.setState({ ShowAddressPopup: true });
    }

    async showClalDriverDetails() {
        this.setState(prevState => ({ clalMainFill: !prevState.clalMainFill }));
    }


    async openPopup() {
        if (localStorage.getItem("isAdminUser") == "true")
            await this.setState({ ShowVehiclePopup: true });

    }

    async calcAges(data: SimulatorData) {
        const stateData = this.state.simulatorData;

        if (!stateData.driverMainBirthDateSpecificDate) {
            data.driverMainBirthDate = this.calculateDateFromAge(data.driverMainAge, data.lead_startDate)
        }
        else {
            data.driverMainAge = calculateAge(data.driverMainBirthDate, data.lead_startDate);
        }

        if (!stateData.driverYoungBirthDateSpecificDate) {
            data.driverYoungBirthDate = this.calculateDateFromAge(data.driverYoungAge, data.lead_startDate);
        }
        else {
            data.driverYoungAge = calculateAge(data.driverYoungBirthDate, data.lead_startDate);
        }

        if (!stateData.driverMainSeniorityDateSpecificDate) {
            data.driverMainSeniorityDate = this.calculateDateFromAge(data.driverMainSeniority, data.lead_startDate);
        }
        else {
            data.driverMainSeniority = calculateAge(data.driverMainSeniorityDate, data.lead_startDate);
        }

        if (!stateData.driverYoungSeniorityDateSpecificDate) {
            data.driverYoungSeniorityDate = this.calculateDateFromAge(data.driverYoungSeniority, data.lead_startDate);
        }
        else {
            data.driverYoungSeniority = calculateAge(data.driverYoungSeniorityDate, data.lead_startDate);
        }

        return data;


    }


    getSimulatorData = () => {
        // 


        var data = new SimulatorData();
        const stateData = this.state.simulatorData;

        data.InsuranceType = stateData.InsuranceType;
        data.startDateSelectValue = stateData.startDateSelectValue;
        data.deductible = stateData.deductible;
        data.insuranceStartDate = stateData.insuranceStartDate;
        data.lead_startDate = stateData.lead_startDate;
        data.lead_endDate = stateData.lead_endDate;
        data.lead_id = stateData.lead_id;
        data.AuthorizedToDrive = stateData.AuthorizedToDrive;
        data.postalCode = stateData.postalCode.trim();
        data.city = stateData.city;
        data.mailBox = stateData.mailbox;
        // 
        data.cityId = data.cityId = typeof stateData.cityId === "string" ? (stateData.cityId.trim().length > 0 ? parseInt(stateData.cityId.trim()) : 0) : stateData.cityId;
        data.address = stateData.address;
        data.street = stateData.street;
        data.houseNumber = stateData.houseNumber;
        data.driverMainAge = stateData.driverMainAge;
        data.driverMainBirthDate = stateData.driverMainBirthDate;
        data.driverMainSeniority = stateData.driverMainSeniority;
        data.driverMainSeniorityDate = stateData.driverMainSeniorityDate;
        data.driverMainGender = stateData.driverMainGender;
        data.driverMainMaritalStatus = stateData.driverMainMaritalStatus;
        data.driverMainBirthDateSpecificDate = stateData.driverMainBirthDateSpecificDate;
        data.driverMainSeniorityDateSpecificDate = stateData.driverMainSeniorityDateSpecificDate;
        if (data.AuthorizedToDrive == 1/*TWO DRIVERS*/ || data.AuthorizedToDrive == 2) {
            data.driverYoungAge = stateData.driverYoungAge;
            data.driverYoungBirthDate = stateData.driverYoungBirthDate;
            data.driverYoungSeniority = stateData.driverYoungSeniority;
            data.driverYoungSeniorityDate = stateData.driverYoungSeniorityDate;
            data.driverYoungGender = stateData.driverYoungGender;
            data.driverYoungMaritalStatus = stateData.driverYoungMaritalStatus;
            data.driverYoungBirthDateSpecificDate = stateData.driverYoungBirthDateSpecificDate;
            data.driverYoungSeniorityDateSpecificDate = stateData.driverYoungSeniorityDateSpecificDate;

        }
        else if (data.AuthorizedToDrive == 0/*ONE DRIVER*/) {
            data.driverYoungAge = stateData.driverMainAge;
            data.driverYoungBirthDate = stateData.driverMainBirthDate;
            data.driverYoungSeniority = stateData.driverMainSeniority;
            data.driverYoungSeniorityDate = stateData.driverMainSeniorityDate;
            data.driverYoungGender = stateData.driverMainGender;
            data.driverYoungMaritalStatus = stateData.driverMainMaritalStatus;
            data.driverYoungBirthDateSpecificDate = stateData.driverMainBirthDateSpecificDate;
            data.driverYoungSeniorityDateSpecificDate = stateData.driverMainSeniorityDateSpecificDate;
        }


        data.esp = stateData.esp;
        data.fcw = stateData.fcw;
        data.ldw = stateData.ldw;
        data.licenseNumber = stateData.licenseNumber;
        data.modelCode = stateData.modelCode;
        data.automaticInd = stateData.automaticInd;
        data.carYear = stateData.carYear;
        data.entryToRoadDate = stateData.entryToRoadDate;
        data.manufacturer = stateData.manufacturer;
        data.vehicleModel = stateData.vehicleModel;
        data.manufacturerId = stateData.manufacturerId;
        data.vehicleModelId = stateData.vehicleModelId;
        data.vehicleSubModelId = stateData.vehicleSubModelId;
        data.passedTypeOfInsurance1 = stateData.passedTypeOfInsurance1;
        data.sueNumber1 = stateData.sueNumber1;
        data.passedTypeOfInsurance2 = stateData.passedTypeOfInsurance2;
        data.sueNumber2 = stateData.sueNumber2;
        data.passedTypeOfInsurance3 = stateData.passedTypeOfInsurance3;
        data.sueNumber3 = stateData.sueNumber3;
        data.passedTypeOfInsurance4 = stateData.passedTypeOfInsurance4;
        data.sueNumber4 = stateData.sueNumber4;
        data.sueBody = stateData.sueBody;
        data.revocationsAmount = stateData.revocationsAmount;
        data.bodyClaimsAmount = stateData.bodyClaimsAmount;
        data.noInsurance = stateData.noInsurance;
        data.vehicleOwnership = stateData.vehicleOwnership;
        data.vehicleOwnership = stateData.vehicleOwnership;
        data.impairmentDeductible = stateData.impairmentDeductible;
        data.renovationAgentsOffice = stateData.renovationAgentsOffice;
        data.renovationCompany = stateData.renovationCompany;
        data.mainVehicle = stateData.mainVehicle;
        data.autodirection = stateData.autodirection;
        data.driveInShabbat = stateData.driveInShabbat;
        data.newForOld = stateData.newForOld;
        data.firstName = stateData.firstName == null ? "Sara" : stateData.firstName;
        data.phoneNumber1 = stateData.phoneNumber1 == null ? "0504117832" : stateData.phoneNumber1;

        return data;

    }


    getOffers = async (event: any) => {

        event.preventDefault();
        // event.stopPropagation();
        var data = this.getSimulatorData();
        data = await this.calcAges(data);
        let valid = await this.simularotValidation(data);

        console.log('valid', valid)
        if (valid) {
            //console.log('SIMULATOR DATA::', data);

            this.props.startLoading();
            console.log('loadingOffers', this.props.loadingOffers)
            this.getAllOffersFromAllCompanies(data).then(() => {
                console.log('loadingOffers after', this.props.loadingOffers)
                this.props.stopLoading()
            });

            // this.getRiders(data);
            // // this.simulatorSaveLead(data);
            // await this.getAyalonOffers(data);
            // await this.getHachsharaOffers(data);
            // await this.getHarelOffers(data);
            // await this.getShomeraOffers(data);
            // await this.getShlomoOffers(data);
            // await this.getMigdalOffers(data);
            // await this.getClalGetOffers(data);
            // await this.getFnxGetOffers(data);
            // await this.getMenoraGetOffers(data);

            console.log('getOffers-1111111')
            // this.props.stopLoading();
        }
    }

    // getAllOffersFromAllCompanies = async (data: any) => {
    //     // let ayalonPromise = this.getAyalonOffers(data);
    //     let fnxPromise = this.getFnxGetOffers(data);
    //     let ankorPromise = this.getAnkorOffers(data);
    //     let hachsharaPromise = this.getHachsharaOffers(data);
    //     let harelPromise = this.getHarelOffers(data);
    //     let shomeraPromise = this.getShomeraOffers(data);
    //     let shlomoPromise = this.getShlomoOffers(data);
    //     let migdalPromise = this.getMigdalOffers(data);
    //     let clalPromise = this.getClalGetOffers(data);
    //     let menoraPromise = this.getMenoraGetOffers(data);

    //     // what happen if one of them fail or take too long?
    //     // write solution for that


    //     await Promise.all([
    //         fnxPromise,
    //         ankorPromise,
    //         hachsharaPromise,
    //         harelPromise,
    //         shomeraPromise,
    //         shlomoPromise,
    //         migdalPromise,
    //         clalPromise,
    //         menoraPromise,
    //                     // ayalonPromise,
    //     ]);
    // }



    // Helper function to add timeout to promises
    withTimeout = <T,>(promise: Promise<T>, timeoutMs: number, label: string): Promise<T> => {
        const timeout = new Promise<T>((_, reject) => {
            setTimeout(() => reject(new Error(`${label} timed out after ${timeoutMs}ms`)), timeoutMs);
        });
        return Promise.race([promise, timeout]);
    }

    getAllOffersFromAllCompanies = async (data: any) => {
        const TIMEOUT_MS = 25000; // 30 seconds timeout

        const promises = [
            { name: 'Riders', promise: this.withTimeout(this.getRiders(data), TIMEOUT_MS, 'Riders') },
            { name: 'FNX', promise: this.withTimeout(this.getFnxGetOffers(data), TIMEOUT_MS, 'FNX') },
            { name: 'Ankor', promise: this.withTimeout(this.getAnkorOffers(data), TIMEOUT_MS, 'Ankor') },
            { name: 'Hachshara', promise: this.withTimeout(this.getHachsharaOffers(data), TIMEOUT_MS, 'Hachshara') },
            { name: 'Harel', promise: this.withTimeout(this.getHarelOffers(data), TIMEOUT_MS, 'Harel') },
            { name: 'Shomera', promise: this.withTimeout(this.getShomeraOffers(data), TIMEOUT_MS, 'Shomera') },
            { name: 'Shlomo', promise: this.withTimeout(this.getShlomoOffers(data), TIMEOUT_MS, 'Shlomo') },
            { name: 'Migdal', promise: this.withTimeout(this.getMigdalOffers(data), TIMEOUT_MS, 'Migdal') },
            { name: 'Clal', promise: this.withTimeout(this.getClalGetOffers(data), TIMEOUT_MS, 'Clal') },
            { name: 'Menora', promise: this.withTimeout(this.getMenoraGetOffers(data), TIMEOUT_MS, 'Menora') },
            { name: 'Ayalon', promise: this.withTimeout(this.getAyalonOffers(data), TIMEOUT_MS, 'Ayalon') },
        ];

        const results = await Promise.allSettled(promises.map(p => p.promise));

        results.forEach((result, index) => {
            if (result.status === 'rejected') {
                console.error(`${promises[index].name} failed:`, result.reason);
                // Optionally update UI to show this company failed
            } else {
                console.log(`${promises[index].name} succeeded`);
            }
        });

        // Filter successful results
        const successfulOffers = results
            .filter((r): r is PromiseFulfilledResult<any> => r.status === 'fulfilled')
            .map(r => r.value);

        return successfulOffers;
    }



    simularotValidation = async (data: SimulatorData) => {

        var startDateValid = await this.startDateValidation(data);
        var postalcodeValid = await this.postalcodeValidation(data);
        var endDateValid = await this.endDateValidation(data);
        var youngAgeValid = await this.youngAgeValidation(data);
        var mainAgeValid = await this.mainAgeValidation(data);
        var mainSeniorityValid = await this.mainSeniorityValidation(data);
        var youngSeniorityValid = await this.youngSeniorityValidation(data);
        var vehicleDetailsValid = await this.vehicleDetailsValidation(data);
        console.log('simularotValidationthis.state.mainAgeError', this.state.mainAgeError);

        //var agesValid = await this.youngBetweenMainAgesValidation(data);
        return startDateValid && postalcodeValid && endDateValid && youngAgeValid && mainAgeValid && mainSeniorityValid && youngSeniorityValid && vehicleDetailsValid;
    }

    startDateValidation = async (data: SimulatorData) => {

        //console.log('startDateValidation', data.lead_startDate, this.state.startDateError);
        if (data.lead_startDate == undefined || !(data.lead_startDate instanceof Date) || GlobalMethods.getDateWithoutTime(data.lead_startDate) < GlobalMethods.getDateWithoutTime(new Date())) {
            await this.setState({ startDateError: "תאריך תחילה לא תקין" });
            //console.log('startDateValidation', data.lead_startDate, this.state.startDateError);
            return false;
        }
        else {
            await this.setState({ startDateError: "" });
            //console.log('startDateValidation', data.lead_startDate, this.state.startDateError);

            return true;
        }


    }

    endDateValidation = async (data: SimulatorData) => {
        if (data.lead_endDate == undefined || !(data.lead_endDate instanceof Date) || GlobalMethods.getDateWithoutTime(data.lead_endDate) < GlobalMethods.getDateWithoutTime(new Date())) {
            await this.setState({ endDateError: "תאריך סיום לא תקין" });

            return false;
        }
        else {
            var months;
            months = (data.lead_endDate.getFullYear() - data.lead_startDate.getFullYear()) * 12;
            months -= data.lead_startDate.getMonth();
            months += data.lead_endDate.getMonth();
            if (months <= 0 ? 0 : months > 13) {
                await this.setState({ endDateError: "טווח תאריכים גדול מהמותר." });
                return false;

            }
            await this.setState({ endDateError: "" });
            return true;
        }

    }

    youngAgeValidation = async (data: SimulatorData) => {
        if (data.AuthorizedToDrive == 0) {
            return true;
        }


        if (data.driverYoungAge == undefined || Number(data.driverYoungAge) < 17 || Number(data.driverYoungAge) > 82
            || data.driverYoungAge == "" || data.driverYoungAge == null || data.driverYoungAge == 0) {
            this.setState({ youngAgeError: "גיל נהג לא תקין" });
            return false;
        }
        else if (!Number.isInteger(Number(data.driverYoungAge))) {
            this.setState({ youngAgeError: "גיל נהג לא תקין" });
            return false;

        } else {
            if (data.AuthorizedToDrive == 1 || (data.AuthorizedToDrive == 2 && this.state.clalMainFill == true)) {
                let valid = await this.youngBetweenMainAgesValidation(data);
                if (valid) {

                    this.setState({ youngAgeError: "" });
                    return true;
                }
                return valid;
            }
        }
        this.setState({ youngAgeError: "" });
        return true;
    }

    mainAgeValidation = async (data: SimulatorData) => {

        // if (data.AuthorizedToDrive == 1) {
        if ((data.AuthorizedToDrive == 0 || data.AuthorizedToDrive == 1) || (data.AuthorizedToDrive == 2 && this.state.clalMainFill == true)) {
            if (data.driverMainAge == undefined || Number(data.driverMainAge) < 17 || Number(data.driverMainAge) > 82
                || data.driverMainAge == "" || data.driverMainAge == null || data.driverMainAge == 0) {

                await this.setState({ mainAgeError: "גיל נהג לא תקין" });
                return false;
            } else if (!Number.isInteger(Number(data.driverMainAge))) {
                this.setState({ mainAgeError: "גיל נהג לא תקין" });
                return false;

            } else {
                if (data.AuthorizedToDrive == 1 || (data.AuthorizedToDrive == 2 && this.state.clalMainFill == true)) {
                    let valid = await this.youngBetweenMainAgesValidation(data);
                    if (valid) {

                        this.setState({ mainAgeError: "" });
                        return true;
                    }
                    return valid;
                }
            }
        }
        return true;
    }


    setFCW = async () => {
        const data = this.state.simulatorData;
        data.fcw = !data.fcw;
        await this.setState({ simulatorData: data });
    }

    setESP = async () => {
        const data = this.state.simulatorData;
        data.esp = !data.esp;
        await this.setState({ simulatorData: data });
    }

    setLDW = async () => {
        const data = this.state.simulatorData;
        data.ldw = !data.ldw;
        await this.setState({ simulatorData: data });
    }

    mainSeniorityValidation = async (data: SimulatorData) => {

        let age = this.state.simulatorData.driverMainAge;
        let seniority = this.state.simulatorData.driverMainSeniority;

        if (data.AuthorizedToDrive == 1 || data.AuthorizedToDrive == 0) {
            if (seniority == undefined || seniority > 82 || Number(seniority) < 0 || age - seniority < 17) {
                if (Number(seniority) < 0 || age - data.driverMainSeniority < 17 || seniority > 82) {
                    console.log('invalid seniority');
                    await this.setState({ seniorityMainError: "וותק לא תקין" });
                    return false;
                }
                else {
                    if (Number(seniority) < 0) {
                        console.log('invalid seniority');
                        await this.setState({ seniorityMainError: "וותק לא תקין" });
                        return false;

                    }
                    console.log('invalid seniority');
                    await this.setState({ seniorityMainError: "וותק לא תקין" });
                    return false;
                }

            }
            else {

                let valid = await this.youngBetweenMainAgesValidation(data);
                if (valid) {
                    console.log('valid seniority 2');
                    await this.setState({ seniorityMainError: "" });
                    return true;
                }
                return valid;

            }
        }
        await this.setState({ seniorityMainError: "" });
        return true;
    }


    youngSeniorityValidation = async (data: SimulatorData) => {
        let age = this.state.simulatorData.driverYoungAge;
        let seniority = this.state.simulatorData.driverYoungSeniority;


        // need to check with Rivka why just 1 and 2 and not 0 also
        if (data.AuthorizedToDrive == 1 || data.AuthorizedToDrive == 2) {
            if (seniority == undefined || Number(seniority) < 0 || age - seniority < 17) {

                this.setState({ seniorityYoungError: "וותק לא תקין" });
                return false;
            }
            else {
                await this.setState({ seniorityYoungError: "" });
                return true;
            }
        }
        this.setState({ seniorityYoungError: "" });
        return true;
    }


    vehicleDetailsValidation = async (data: SimulatorData) => {

        let licenseNumberError = false;
        let entryToRoadDateError = false;
        let manufacturerError = false;
        let vehicleModelError = false;
        let vehicleSubModelError = false;


        if (data.entryToRoadDate == null || data.entryToRoadDate == undefined) {
            await this.setState({ entryToRoadDateError: "שדה חובה" });
            entryToRoadDateError = false;
        } else if (moment(data.entryToRoadDate).format('YYYY-MM-DD') == "0001-01-01") {
            await this.setState({ entryToRoadDateError: "יש לעדכן תאריך עליה לכביש" });
            entryToRoadDateError = false;
        } else {
            await this.setState({ entryToRoadDateError: "" });
            entryToRoadDateError = true;
        }

        if (data.manufacturer == null || data.manufacturer == undefined || data.manufacturer.length == 0) {
            await this.setState({ manufacturerError: "שדה חובה" });
            manufacturerError = false
        } else {
            await this.setState({ manufacturerError: "" });
            manufacturerError = true;
        }

        if (data.vehicleModel == null || data.vehicleModel == undefined || data.vehicleModel == 0) {
            await this.setState({ vehicleModelError: "שדה חובה" });
            vehicleModelError = false;
        } else {
            await this.setState({ vehicleModelError: "" });
            vehicleModelError = true;
        }

        if (data.vehicleSubModelId == null || data.vehicleSubModelId == 0) {
            await this.setState({ vehicleSubModelError: "שדה חובה" });
            vehicleSubModelError = false;
        } else {
            await this.setState({ vehicleSubModelError: "" });
            vehicleSubModelError = true;
        }

        //this.state.simulatorData!=null ? this.state.simulatorData.licenseNumber:""
        if ((data.licenseNumber == undefined || data.licenseNumber == "") && (data.modelCode == undefined || data.modelCode == "")) {
            await this.setState({ vehicleDetailsError: "חובה לבחור מס רכב או קוד דגם" });
            licenseNumberError = false;
        }
        else if (data.vehicleSubModelId == null) {
            await this.setState({ vehicleDetailsError: "חסר פרטי רכב" });
            licenseNumberError = false;
        }
        else {
            await this.setState({ vehicleDetailsError: "" });
            licenseNumberError = true;
        }


        return licenseNumberError && entryToRoadDateError && manufacturerError && vehicleModelError && vehicleSubModelError;
    }

    postalcodeValidation = (data: SimulatorData) => {

        //this.state.simulatorData!=null ? this.state.simulatorData.licenseNumber:""
        if ((data.postalCode == undefined || data.postalCode.trim().length == 0)) {
            this.setState({ PostalcodeError: "* שדה חובה" })

            return false;
        }
        if (data.cityId == null || data.cityId == 0) {
            this.setState({ PostalcodeError: "לא נמצאה עיר" })

            return false;
        }
        this.setState({ PostalcodeError: "" })
        return true;
    }

    getRiders = async (data: SimulatorData) => {
        var riders = await new SimulatorModel().getRiders(data);

        this.props.loadRiders(riders);
    }

    getAyalonOffers = async (data: SimulatorData) => {
        try {
            //console.log('|SimulatorData', data);
            var ayalonData = await new SimulatorModel().ayalonGetOffers(data);
            await this.props.loadOffers(ayalonData);
        } catch (error) {

        }
    }
    getAnkorOffers = async (data: SimulatorData) => {
        try {
            //console.log('|SimulatorData', data);
            var ankorData = await new SimulatorModel().ankorGetOffers(data);
            await this.props.loadOffers(ankorData);
        } catch (error) {

        }
    }

    getHachsharaOffers = async (data: SimulatorData) => {
        try {
            var ayalonData = await new SimulatorModel().hachsharaGetOffers(data);
            await this.props.loadOffers(ayalonData);
        } catch (error) {

        }
    }

    getHarelOffers = async (data: SimulatorData) => {
        try {
            var ayalonData = await new SimulatorModel().harelGetOffers(data);

            await this.props.loadOffers(ayalonData);

        } catch (error) {

        }
    }

    getShomeraOffers = async (data: SimulatorData) => {
        try {
            var ayalonData = await new SimulatorModel().shomeraGetOffers(data);
            await this.props.loadOffers(ayalonData);
        } catch (error) {

        }
    }

    simulatorSaveLead = async (data: SimulatorData) => {
        try {
            // 
            await new SimulatorModel().simulatorSaveLead(data);

        } catch (error) {

        }
    }

    getShlomoOffers = async (data: SimulatorData) => {
        try {
            var ayalonData = await new SimulatorModel().shlomoGetOffers(data);
            // 
            await this.props.loadOffers(ayalonData);
        } catch (error) {

        }
    }

    getMigdalOffers = async (data: SimulatorData) => {
        try {
            var ayalonData = await new SimulatorModel().migdalGetOffers(data);
            await this.props.loadOffers(ayalonData);
        } catch (error) {

        }
    }


    getFnxGetOffers = async (data: SimulatorData) => {
        try {
            var ayalonData = await new SimulatorModel().fnxGetOffers(data);
            this.props.loadOffers(ayalonData);
        } catch (error) {

        }
    }

    getMenoraGetOffers = async (data: SimulatorData) => {
        try {
            var ayalonData = await new SimulatorModel().menoraGetOffers(data);
            this.props.loadOffers(ayalonData);
        } catch (error) {

        }
    }

    getClalGetOffers = async (data: SimulatorData) => {
        try {
            var ayalonData = await new SimulatorModel().clalGetOffers(data);
            this.props.loadOffers(ayalonData);
        } catch (error) {

        }
    }






    cleanScreen = async (event: any) => {
        window.location.reload();
        //this.load();
    }



    render() {





        return (<>
            {
                this.state.loading && (
                    <PleaseWaitLayer />
                )
            }
            <section className="simulator-form">
                {this.props.data ? (<>
                    <div className="simulator-row">
                        <div className="cell ">
                            <div>
                                סוג ביטוח
                            </div>
                            <div>
                                <div className="filter-input">
                                    {this.state.InsuranceTypes ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"InsuranceType"}

                                        Options={this.state.InsuranceTypes} Value={this.state.simulatorData != null ? this.state.simulatorData.InsuranceType : null} />
                                    ) : ""}

                                </div>
                            </div>
                        </div>
                        {/* <div className='cell deductibleDiv'>
            <input  type="checkbox" onChange={(e:any) =>  this.setCheckboxStateData("deductible", e)}  checked={this.state.simulatorData!=null?this.state.simulatorData.deductible:false} />
                <label>השתתפות עצמית</label>
                
                
            </div> */}
                    </div>
                    <div className="simulator-row">

                        <div className="cell">
                            <div>
                                תאריך התחלה
                            </div>
                            <div className='error-message-parent'>
                                <div className="filter-input startDateSelectDiv">


                                    <DynamicSelect ClassName={this.state.simulatorData.startDateSelectValue == 3 ? "hide" : ""} OnChange={this.startDateSelectChange} Value={this.state.simulatorData.startDateSelectValue} Options={this.props.data != null && this.props.data.startDateSelect != null ? this.props.data.startDateSelect.map((x: any) => ({ Text: x.text, Value: x.value })) : []} Id={"startDateSelectValue"} />
                                    <div className={this.state.simulatorData.startDateSelectValue == 3 ? "start-datepickerDiv" : "start-datepickerDiv  hide"}>
                                        {/* <DatePicker
                                ref={this.startDateRef}
                                selected={this.state.simulatorData.lead_startDate}
                                onSelect={(e:any) => this.setStartDate("lead_startDate", e)}
                                onChange={(e:any) =>  this.setStartDate("lead_startDate", e)}
                                dateFormat='dd/MM/yyyy'
                            /> */}
                                        <CompDatePicker value={this.state.simulatorData.lead_startDate} onChange={(date: Date) => this.setStartDate("lead_startDate", date)} />
                                        <div className="icon x-clear" onClick={(e: any) => this.startDateSelectChange("startDateSelectValue", 1)}></div>
                                        <input type='hidden' value={this.state.simulatorData.lead_startDate} onChange={(e: any) => this.calcEndDate()} />
                                    </div>


                                </div>
                                <div className='error-message'>{this.state.startDateError}</div>

                            </div>
                        </div>
                        <div className="cell endDate error-message-parent">
                            <div>
                                תאריך סיום
                            </div>
                            <div className='filter-input'>
                                {/* <DatePicker
                        selected={this.state.simulatorData.lead_endDate}
                        onSelect={(e:any) => this.setEndDate("lead_endDate", e)}
                        onChange={(e:any) =>  this.setEndDate("lead_endDate", e)}
                        dateFormat='dd/MM/yyyy'
                        className='endDateInput'
                    /> */}
                                <CompDatePicker value={this.state.simulatorData.lead_endDate} onChange={(date: Date) => this.setEndDate("lead_endDate", date)} />
                            </div>
                            <div className='daysDiv'>
                                {this.state.simulatorData != null ? this.datediff(this.state.simulatorData.lead_startDate, this.state.simulatorData.lead_endDate) : ""} ימים
                            </div>
                            <div className='error-message'>{this.state.endDateError}</div>

                        </div>



                    </div>
                    <div className="simulator-row">
                        <div className="cell">
                            <div>
                                נהגים
                            </div>
                            <div>
                                <div className="filter-input">
                                    {this.state.AuthorizedToDrive ? (<IDNameDescriptionItemSelect OnChange={this.setAuthorizedToDrive}
                                        Id={"AuthorizedToDrive"} Options={this.state.AuthorizedToDrive} Value={this.state.simulatorData != null ? this.state.simulatorData.AuthorizedToDrive : null} />
                                    ) : ""}

                                </div>
                            </div>
                        </div>
                        <div className="cell">
                            <div>
                                מיקוד
                            </div>
                            <div>
                                <div className="filter-input">
                                    <input type="text" onChange={(e: any) => this.setPostalCode("postalCode", e)} onBlur={(e: any) => this.loadPostalCode("postalCode", e)} value={this.state.simulatorData != null ? this.state.simulatorData.postalCode : ""} />
                                    <img src={require("./assets/images/loading.gif")} className={this.state.postalCodeSpiner ? "loadingGif" : "hide"} />
                                    <div className="icon location" onClick={() => this.openAddressPopup()}></div>
                                </div>
                                <div>{this.state.simulatorData ? this.state.simulatorData.address : ""}</div>
                                <div className='error-message'>{this.state.PostalcodeError}</div>

                            </div>
                        </div>
                    </div>

                    <div>
                        <div className={this.state.simulatorData != null && (this.state.simulatorData.AuthorizedToDrive == "1" || this.state.simulatorData.AuthorizedToDrive == "2") ? "row-title" : "hide"}>
                            הנהג הצעיר
                        </div>

                        <div className={this.state.simulatorData != null && (this.state.simulatorData.AuthorizedToDrive == "1" || this.state.simulatorData.AuthorizedToDrive == "2") ? "simulator-row" : "hide"}>
                            <div className="cell error-message-parent">
                                <div>
                                    גיל
                                </div>
                                <div className="filter-input ageSeniorityCalendar">
                                    <input type="number" className='smallInput' id="driverYoungAge" onChange={(e: any) => this.setDriverAge("driverYoungAge", e)} onFocus={() => { this.setState({ youngAgeError: '' }) }} value={this.state.simulatorData != null ? this.state.simulatorData.driverYoungAge : ""} />
                                    <DatePicker
                                        ref={this.driverYoungAgeRef}
                                        selected={this.state.simulatorData.driverYoungBirthDate}
                                        onSelect={(e: any) => this.setDriverDate("driverYoungBirthDate", e)}
                                        onChange={(e: any) => this.setDriverDate("driverYoungBirthDate", e)}
                                        showTimeInput={false}
                                        showYearDropdown
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={50}
                                        minDate={new Date(1900, 1, 1)} // Set a minimum date far in the past
                                        maxDate={new Date(2026, 11, 31)} // Set a maximum date far in the future
                                        scrollableMonthYearDropdown
                                        scrollableYearDropdown
                                        useShortMonthInDropdown
                                    />
                                    <div className="icon calendar" onClick={(e: any) => { if (this.driverYoungAgeRef.current != null) this.driverYoungAgeRef.current.setOpen(true) }}></div>


                                </div>
                                {/* <div className='error-message'>{this.state.youngAgeError}</div> */}

                                {/* <div className='error-message' style={{ position: 'absolute' }}>{this.state.youngAgeError2}</div> */}
                                {/* <div className='error-message' style={{ position: 'absolute', top: '60px' }}>{this.state.seniorityYoungError2}</div> */}
                            </div>
                            <div className="cell error-message-parent">
                                <div>
                                    שנות ותק
                                </div>
                                <div className="filter-input ageSeniorityCalendar">
                                    <input type="number" className='smallInput' id="driverYoungSeniority" min="0" onChange={(e: any) => this.setDriverAge("driverYoungSeniority", e)} onFocus={() => { this.setState({ seniorityYoungError: '' }) }} value={this.state.simulatorData != null ? this.state.simulatorData.driverYoungSeniority : ""} />
                                    <DatePicker
                                        ref={this.driverYoungSeniorityDateRef}
                                        selected={this.state.simulatorData.driverYoungSeniorityDate}
                                        onSelect={(e: any) => this.setDriverDate("driverYoungSeniorityDate", e)}
                                        onChange={(e: any) => this.setDriverDate("driverYoungSeniorityDate", e)}
                                        showTimeInput={false}
                                        showYearDropdown
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={50}
                                        minDate={new Date(1900, 1, 1)} // Set a minimum date far in the past
                                        maxDate={this.state.simulatorData ? this.state.simulatorData.lead_startDate : new Date()}
                                        scrollableMonthYearDropdown
                                        scrollableYearDropdown
                                        useShortMonthInDropdown
                                    />

                                    <div className="icon calendar" onClick={(e: any) => { if (this.driverYoungSeniorityDateRef.current != null) this.driverYoungSeniorityDateRef.current.setOpen(true) }}></div>

                                </div>
                                {/* <div className='error-message'>{this.state.seniorityYoungError}</div> */}
                            </div>
                            <div className="cell">
                                <div>
                                    מגדר
                                </div>
                                <div className="filter-input">
                                    {this.state.Geder ? (<IDNameDescriptionItemSelect OnChange={this.setYoungGender} Id={"driverYoungGender"} Options={this.state.Geder} Value={this.state.simulatorData != null ? this.state.simulatorData.driverYoungGender : null} />
                                    ) : ""}
                                </div>
                            </div>
                            <div className="cell">
                                <div>
                                    סטטוס
                                </div>
                                <div className="filter-input">
                                    {this.state.MaritalStatus ? (<IDNameDescriptionItemSelect OnChange={this.setYoungMaritalStatus} Id={"driverYoungMaritalStatus"} Options={this.state.MaritalStatus} Value={this.state.simulatorData != null ? this.state.simulatorData.driverYoungMaritalStatus : null} />
                                    ) : ""}


                                </div>
                            </div>

                        </div>
                        <div className={this.state.simulatorData != null && (this.state.simulatorData.AuthorizedToDrive == "1" || this.state.simulatorData.AuthorizedToDrive == "2") ? "error-message-parent" : "hide"}>
                            {this.state.youngAgeError != "" ? <li className='error-message'>{this.state.youngAgeError}</li> : ""}
                            {this.state.seniorityYoungError != "" ? <li className='error-message'>{this.state.seniorityYoungError}</li> : ""}
                        </div>
                    </div>
                    <div>
                        <button className={this.state.simulatorData != null && this.state.simulatorData.AuthorizedToDrive == "2" ? "clalComment" : "hide"} onClick={() => this.showClalDriverDetails()}>לחץ לעדכון פרטי בעל הרכב - בחברת כלל בלבד</button>
                        <div className={this.state.simulatorData != null && (this.state.simulatorData.AuthorizedToDrive == "1" || this.state.simulatorData.AuthorizedToDrive == "0" || (this.state.simulatorData.AuthorizedToDrive == "2" && this.state.clalMainFill == true)) ? "row-title" : "hide"}>
                            הנהג העיקרי
                        </div>


                        <div className={this.state.simulatorData != null && (this.state.simulatorData.AuthorizedToDrive == "1" || this.state.simulatorData.AuthorizedToDrive == "0" || (this.state.simulatorData.AuthorizedToDrive == "2" && this.state.clalMainFill == true)) ? "simulator-row" : "hide"} >
                            <div className="cell error-message-parent">
                                <div>
                                    גיל
                                </div>
                                <div className="filter-input ageSeniorityCalendar">
                                    <input type="number" id="driverMainAge" onChange={(e: any) => this.setDriverAge("driverMainAge", e)} onFocus={() => { this.setState({ mainAgeError: '' }) }} value={this.state.simulatorData != null ? this.state.simulatorData.driverMainAge : ""} />

                                    <DatePicker
                                        ref={this.driverMainAgeRef}
                                        selected={this.state.simulatorData.driverMainBirthDate}
                                        onSelect={(e: any) => this.setDriverDate("driverMainBirthDate", e)}
                                        onChange={(e: any) => this.setDriverDate("driverMainBirthDate", e)}
                                        showTimeInput={false}
                                        showYearDropdown
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={50}
                                        minDate={new Date(1900, 1, 1)} // Set a minimum date far in the past
                                        maxDate={new Date(2026, 11, 31)} // Set a maximum date far in the future
                                        scrollableMonthYearDropdown
                                        scrollableYearDropdown
                                        useShortMonthInDropdown
                                    />
                                    <div className="icon calendar" onClick={(e: any) => { if (this.driverMainAgeRef.current != null) this.driverMainAgeRef.current.setOpen(true) }}></div>

                                </div>
                                {/* <div className='error-message'>{this.state.mainAgeError}</div> */}
                            </div>
                            <div className="cell error-message-parent">
                                <div>
                                    שנות ותק
                                </div>
                                <div className="filter-input ageSeniorityCalendar">
                                    <input type="number" min="0" id="driverMainSeniority" onChange={(e: any) => this.setDriverAge("driverMainSeniority", e)} onFocus={() => { this.setState({ seniorityMainError: '' }) }} value={this.state.simulatorData != null ? this.state.simulatorData.driverMainSeniority : ""} />
                                    <DatePicker
                                        ref={this.driverMainSeniorityDateRef}
                                        selected={this.state.simulatorData.driverMainSeniorityDate}
                                        onSelect={(e: any) => this.setDriverDate("driverMainSeniorityDate", e)}
                                        onChange={(e: any) => this.setDriverDate("driverMainSeniorityDate", e)}
                                        showTimeInput={false}
                                        showYearDropdown
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={50}
                                        minDate={new Date(1900, 1, 1)} // Set a minimum date far in the past                                        
                                        maxDate={this.state.simulatorData ? this.state.simulatorData.lead_startDate : new Date()}
                                        scrollableMonthYearDropdown
                                        scrollableYearDropdown
                                        useShortMonthInDropdown
                                    />

                                    <div className="icon calendar" onClick={(e: any) => { if (this.driverMainSeniorityDateRef.current != null) this.driverMainSeniorityDateRef.current.setOpen(true) }}></div>

                                </div>
                                {/* <div className='error-message'>{this.state.seniorityMainError}</div> */}
                            </div>
                            <div className="cell">
                                <div>
                                    מגדר
                                </div>
                                <div className="filter-input">
                                    {this.state.Geder ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"driverMainGender"} Options={this.state.Geder} Value={this.state.simulatorData != null ? this.state.simulatorData.driverMainGender : null} />
                                    ) : ""}
                                </div>
                            </div>
                            <div className="cell">
                                <div>
                                    סטטוס
                                </div>
                                <div className="filter-input">
                                    {this.state.MaritalStatus ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"driverMainMaritalStatus"} Options={this.state.MaritalStatus} Value={this.state.simulatorData != null ? this.state.simulatorData.driverMainMaritalStatus : null} />
                                    ) : ""}
                                </div>
                            </div>

                        </div>
                        <div className={this.state.simulatorData != null && (this.state.simulatorData.AuthorizedToDrive == "1" || this.state.simulatorData.AuthorizedToDrive == "0" || (this.state.simulatorData.AuthorizedToDrive == "2" && this.state.clalMainFill == true)) ? "error-message-parent" : "hide"} >
                            {this.state.mainAgeError != "" ? <li className='error-message'>{this.state.mainAgeError}</li> : ""}
                            {this.state.seniorityMainError != "" ? <li className='error-message'>{this.state.seniorityMainError}</li> : ""}
                        </div>
                    </div>
                    <div className="simulator-row">
                        <div className="row-title">רכב</div>
                        <div className="flex-centered flex-space-between">
                            <div onClick={(e: any) => this.setESP()} className={`car-type ${this.state.simulatorData != null && this.state.simulatorData.esp ? "black" : ""}`} >ESP</div>
                            <div onClick={(e: any) => this.setFCW()} className={`car-type ${this.state.simulatorData != null && this.state.simulatorData.fcw ? "black" : ""}`} >FCW</div>
                            <div onClick={(e: any) => this.setLDW()} className={`car-type ${this.state.simulatorData != null && this.state.simulatorData.ldw ? "black" : ""}`} >LDW</div>
                        </div>
                    </div>
                    <div className="simulator-row">
                        <div className="cell">
                            <div>
                                מספר רכב
                            </div>
                            <div className='error-message-parent'>
                                <div className="filter-input">
                                    <input type="text" value={this.state.simulatorData != null ? this.state.simulatorData.licenseNumber : ""} id='licenseNumber' onKeyDown={(e: any) => this.getVehicleDetailsKeyPress(e)} onChange={(e: any) => this.licenseNumberChange(e)} onBlur={this.getVehicleDetails}
                                        disabled={this.props.data.lead && this.props.data.lead.vehicle && this.props.data.lead.vehicle.modelCode && this.props.data.lead.vehicle.modelCode != "" ? true : false}
                                    />
                                    <img src={require("./assets/images/loading.gif")} className={this.state.simulatorData != null && this.state.simulatorData.licenseNumberLoading ? "loadingGif" : "hide"} />
                                </div>
                                <div className='error-message'>{this.state.vehicleDetailsError}</div>

                            </div>
                        </div>
                        <div className="cell">
                            <div>
                                קוד דגם
                            </div>
                            <div>
                                <div className="filter-input">




                                    <Autocomplete2 Value={this.state.simulatorData != null ? this.state.simulatorData.modelCode : ""} Id="modelCode"
                                        ClassName=''
                                        OnChange={this.loadModelCode}
                                        OnSelect={this.selectModelCode}
                                        OnBlur={(value: string) => this.getModelDataByCode(value, this.state.simulatorData.licenseNumber)}
                                        DataList={this.state.ModelcodeAutocomplete}
                                        Disabled={this.props.data.lead && this.props.data.lead.vehicle && this.props.data.lead.vehicle.modelCode && this.props.data.lead.vehicle.modelCode != "" ? true : false}
                                    />
                                    <img src={require("./assets/images/loading.gif")} className={this.state.codeModelLoading ? "loadingGif" : "hide"} />
                                </div>
                                
                            </div>
                        </div>
                        <div className="cell">
                            <div>
                                אוטומטי?
                            </div>
                            <div>
                                <div className="">
                                    <input onChange={(e: any) => this.setCheckboxStateData("automaticInd", e)} type="checkbox" checked={this.state.simulatorData != null && this.state.simulatorData.automaticInd != null ? this.state.simulatorData.automaticInd : true} />


                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="simulator-row">
                        <div className="cell">
                            <div>
                                שנה
                            </div>
                            <div>
                                <div className="filter-input">
                                    <DynamicSelect ClassName="" OnChange={this.setStateData} Value={this.state.simulatorData != null ? this.state.simulatorData.carYear : ""} Options={this.state.CarYear != null ? this.state.CarYear.map((x: string) => ({ Text: x, Value: x })) : []} Id={"carYear"} />
                                </div>
                            </div>
                        </div>
                        <div className="cell">
                            <div>
                                ת.ע. לכביש
                            </div>
                            <div className='error-message-parent'>
                                <div className="filter-input">
                                    {/* <input type="text" onChange={(e:any) =>  this.setStateInputData("entryToRoadDate", e)} value={this.state.simulatorData!=null && this.state.simulatorData.entryToRoadDate!=null ? (new Date(this.state.simulatorData.entryToRoadDate)).toLocaleDateString('he-IL').replaceAll('.','/'):""} /> */}

                                    {/* <DatePicker
                                ref={this.entryToRoadDateRef}
                                selected={this.state.simulatorData.entryToRoadDate ? this.state.simulatorData.entryToRoadDate:""}
                                onSelect={(e:any) => this.setEndDate("entryToRoadDate", e)}
                                onChange={(e:any) =>  this.setEndDate("entryToRoadDate", e)}
                                dateFormat='dd/MM/yyyy'
                            /> */}

                                    <CompDatePicker value={this.state.simulatorData.entryToRoadDate ? this.state.simulatorData.entryToRoadDate : ""} onChange={(date: Date) => this.setEndDate("entryToRoadDate", date)} />
                                    {/* <div className="icon calendar"></div> */}
                                </div>
                                <div className='error-message'>{this.state.entryToRoadDateError}</div>
                            </div>
                        </div>
                        <div className="cell">
                            <div>
                                יצרן
                            </div>

                            <div className='error-message-parent'>
                                <div className="filter-input">

                                    <Autocomplete Value={this.state.simulatorData != null ? this.state.simulatorData.manufacturer : ""} Id="manufacturer"
                                        ClassName=''
                                        OnChange={this.loadManufacturer}
                                        OnSelect={this.selectManufacturer}
                                        DataList={this.state.ManufacturerAutocomplete}
                                        Disabled={this.props.data.lead && this.props.data.lead.vehicle && this.props.data.lead.vehicle.modelCode && this.props.data.lead.vehicle.modelCode != "" ? true : false}
                                    />
                                </div>
                                <div className='error-message'>{this.state.manufacturerError}</div>

                            </div>
                        </div>
                    </div>
                    <div className="simulator-row">
                        <div className="cell">
                            <div>
                                דגם
                            </div>
                            <div className='error-message-parent'>

                                <div className="filter-input">
                                    <Autocomplete Value={this.state.simulatorData != null ? this.state.simulatorData.vehicleModel : ""} Id="vehicleModel"
                                        ClassName=''
                                        OnChange={this.loadVehicleModel}
                                        OnSelect={this.selectVehicleModel}
                                        DataList={this.state.VehicleModelAutocomplete}
                                        Disabled={this.props.data.lead && this.props.data.lead.vehicle && this.props.data.lead.vehicle.modelCode && this.props.data.lead.vehicle.modelCode != "" ? true : false}
                                    // dilay={1500}
                                    />
                                </div>
                                <div className='error-message'>{this.state.vehicleModelError}</div>
                            </div>
                        </div>
                        <div className="cell">
                            <div>
                                תת דגם
                            </div>
                            <div className='error-message-parent'>
                                <div className="filter-input">
                                    <Autocomplete Value={this.state.simulatorData != null ? this.state.simulatorData.vehicleSubModel : ""} Id="vehicleSubModel"
                                        ClassName=''
                                        OnChange={this.loadVehicleSubModel}
                                        OnSelect={this.selectVehicleSubModel}
                                        DataList={this.state.VehicleSubModelAutocomplete}
                                        Disabled={this.props.data.lead && this.props.data.lead.vehicle && this.props.data.lead.vehicle.modelCode && this.props.data.lead.vehicle.modelCode != "" ? true : false}

                                    />
                                </div>
                                <div className='error-message'>{this.state.vehicleSubModelError}</div>
                            </div>
                        </div>
                        {this.props.data.lead && this.props.data.lead.vehicle && this.props.data.lead.vehicle.modelCode && this.props.data.lead.vehicle.modelCode != "" ? "" :
                            <div className={"parameter-row"}><div className={this.state.showVehicleDetails ? (this.state.missingVehicleDetails ? "editRed" : "edit") : "hide"} onClick={(e: any) => this.openPopup()} ><FontAwesomeIcon icon={faPenToSquare} /></div></div>
                        }
                    </div>
                    <div>
                        <div className="simulator-row">
                            <div className="cell">
                                <div className="row-title">
                                    עבר ביטוחי
                                </div>
                            </div>
                            <div className="cell">
                                <div>
                                    סוג ביטוח
                                </div>
                            </div>
                            <div className="cell">
                                <div>
                                    מספר תביעות
                                </div>
                            </div>
                        </div>
                        <div className="simulator-row">
                            <div className="cell">
                                <div>
                                    שנה אחרונה
                                </div>
                            </div>
                            <div className="cell">
                                <div className="filter-input">
                                    {this.state.PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"passedTypeOfInsurance1"} Options={this.state.PassedTypeOfInsurance} Value={this.props.data != null && this.state.simulatorData != null ? this.state.simulatorData.passedTypeOfInsurance1 : null} />
                                    ) : ""}
                                </div>
                            </div>
                            <div className="cell">
                                <div className="filter-input">
                                    <input type="number" id="sueNumber1" onChange={(e: any) => this.setStateInputData("sueNumber1", e)} value={this.state.simulatorData != null ? this.state.simulatorData.sueNumber1 : ""} />
                                </div>
                            </div>
                        </div>
                        <div className="simulator-row">
                            <div className="cell">
                                <div>
                                    לפני שנתיים
                                </div>
                            </div>
                            <div className="cell">
                                <div className="filter-input">
                                    {this.state.PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"passedTypeOfInsurance2"} Options={this.state.PassedTypeOfInsurance} Value={this.props.data != null && this.state.simulatorData != null ? this.state.simulatorData.passedTypeOfInsurance2 : null} />
                                    ) : ""}
                                </div>
                            </div>
                            <div className="cell">
                                <div className="filter-input">
                                    <input type="number" id="sueNumber2" onChange={(e: any) => this.setStateInputData("sueNumber2", e)} value={this.state.simulatorData != null ? this.state.simulatorData.sueNumber2 : ""} />
                                </div>
                            </div>
                        </div>
                        <div className="simulator-row">
                            <div className="cell">
                                <div>
                                    לפני 3 שנים
                                </div>
                            </div>
                            <div className="cell">
                                <div className="filter-input">
                                    {this.state.PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"passedTypeOfInsurance3"} Options={this.state.PassedTypeOfInsurance} Value={this.props.data != null && this.state.simulatorData != null ? this.state.simulatorData.passedTypeOfInsurance3 : null} />
                                    ) : ""}
                                </div>
                            </div>
                            <div className="cell">
                                <div className="filter-input">
                                    <input type="number" id="sueNumber3" onChange={(e: any) => this.setStateInputData("sueNumber3", e)} value={this.state.simulatorData != null ? this.state.simulatorData.sueNumber3 : ""} />
                                </div>
                            </div>
                        </div>
                        <div className="simulator-row">
                            <div className="cell">
                                <div>
                                    לפני 4 שנים
                                </div>
                            </div>
                            <div className="cell">
                                <div className="filter-input">
                                    {this.state.PassedTypeOfInsurance ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"passedTypeOfInsurance4"} Options={this.state.PassedTypeOfInsurance} Value={this.props.data != null && this.state.simulatorData != null ? this.state.simulatorData.passedTypeOfInsurance4 : null} />
                                    ) : ""}
                                </div>
                            </div>
                            <div className="cell">
                                <div className="filter-input">
                                    <input type="number" id="sueNumber4" onChange={(e: any) => this.setStateInputData("sueNumber4", e)} value={this.state.simulatorData != null ? this.state.simulatorData.sueNumber4 : ""} />
                                </div>
                            </div>
                        </div>
                        <div className="simulator-row">
                            <div className="third-cell cell">
                                <div className='small-title'>
                                    תביעות גוף
                                </div>
                            </div>

                            <div className="cell two-thirds-cell">
                                <div className="filter-input">
                                    <input type="number" id="bodyClaimsAmount" onChange={(e: any) => this.setStateInputData("bodyClaimsAmount", e)} value={this.state.simulatorData != null ? this.state.simulatorData.bodyClaimsAmount : ""} />
                                </div>
                            </div>

                        </div>
                        <div className="simulator-row">
                            <div className="third-cell cell">
                                <div className='small-title'>
                                    שלילות
                                </div>
                            </div>

                            <div className="cell two-thirds-cell">
                                <div className="filter-input">
                                    <input type="number" id="revocationsAmount" onChange={(e: any) => this.setStateInputData("revocationsAmount", e)} value={this.state.simulatorData != null ? this.state.simulatorData.revocationsAmount : ""} />
                                </div>
                            </div>
                        </div>
                        <div className="simulator-row">
                            <div className="cell noInsuranceDiv">
                                <div>
                                    <input onChange={(e: any) => this.setNoInsurance("noInsurance", e)} type="checkbox" checked={this.state.simulatorData != null ? this.state.simulatorData.noInsurance : false} />
                                    מבוטח ללא עבר ביטוחי
                                </div>
                            </div>


                        </div>
                    </div>
                    <div className="simulator-row">
                        <div className="row-title">פרטים נוספים והרחבות</div>
                    </div>
                    <div className="simulator-row">
                        <div className="cell">
                            <div>
                                בעלות הרכב
                            </div>
                            <div>
                                <div className="filter-input">
                                    {this.state.VehicleOwnership ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"vehicleOwnership"} Options={this.state.VehicleOwnership} Value={this.props.data != null && this.state.simulatorData != null ? this.state.simulatorData.vehicleOwnership : null} />
                                    ) : ""}
                                </div>
                            </div>
                        </div>
                        <div className="cell">
                            <div>
                                ה.ע. בירידת ערך
                            </div>
                            <div>
                                <div className="filter-input">
                                    {this.state.ImpairmentDeductible ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"impairmentDeductible"} Options={this.state.ImpairmentDeductible} Value={this.props.data != null && this.state.simulatorData != null ? this.state.simulatorData.impairmentDeductible : null} />
                                    ) : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="simulator-row">
                        <div className="cell">
                            <div>
                                חידוש במ. הסוכן
                            </div>
                            <div>
                                <div className="filter-input">
                                    {this.state.RenovationAgentsOffice ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"renovationAgentsOffice"} Options={this.state.RenovationAgentsOffice} Value={this.props.data != null && this.state.simulatorData != null ? this.state.simulatorData.renovationAgentsOffice : null} />
                                    ) : ""}
                                </div>
                            </div>
                        </div>
                        <div className="cell">
                            <div>
                                חידוש בחברה
                            </div>
                            <div>
                                <div className="filter-input">
                                    {this.state.RenovationCompany ? (<IDNameDescriptionItemSelect OnChange={this.setStateData} Id={"renovationCompany"} Options={this.state.RenovationCompany} Value={this.props.data != null && this.state.simulatorData != null ? this.state.simulatorData.renovationCompany : null} />
                                    ) : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="simulator-row">
                            <div className="cell checkbox">
                                <div>
                                    <input onChange={(e: any) => this.setCheckboxStateData("mainVehicle", e)} type="checkbox" checked={this.state.simulatorData != null ? this.state.simulatorData.mainVehicle : false} />

                                </div>
                                <div>
                                    משמש כרכב עיקרי
                                </div>
                            </div>
                        </div>
                        <div className="simulator-row">
                            <div className="cell checkbox">
                                <div>
                                    <input onChange={(e: any) => this.setCheckboxStateData("autodirection", e)} type="checkbox" checked={this.state.simulatorData != null ? this.state.simulatorData.autodirection : false} />

                                </div>
                                <div>
                                    כינון אוטומטי
                                </div>
                            </div>
                        </div>
                        <div className="simulator-row">
                            <div className="cell checkbox">
                                <div>
                                    <input onChange={(e: any) => this.setCheckboxStateData("driveInShabbat", e)} type="checkbox" checked={this.state.simulatorData != null ? this.state.simulatorData.driveInShabbat : true} />

                                </div>
                                <div>
                                    הרכב נוסע בשבת
                                </div>
                            </div>
                        </div>
                        <div className="simulator-row">
                            <div className="cell checkbox">
                                <div>
                                    <input onChange={(e: any) => this.setCheckboxStateData("newForOld", e)} type="checkbox" checked={this.state.simulatorData != null ? this.state.simulatorData.newForOld : false} />

                                </div>
                                <div>
                                    חדש תמורת ישן
                                </div>
                            </div>
                        </div>

                    </div>

                </>) : (
                    <p>loading...</p>
                )}







            </section>
            <div className="row simulator-row _separetor">
                <div className="fullWidth">
                    <div id="clean" className="cell clean-btn" onClick={(e: any) => this.cleanScreen(e)}>נקה</div>
                    <div id="submitSimulator" className="cell suggestions-btn  " onClick={(e: any) => this.getOffers(e)}>צפייה בהצעות</div>
                </div>

            </div>
            <div className={this.state.ShowVehiclePopup ? "" : "hide"}>
                <VehicleDetails manufacturerId={this.state.Vehicle && this.state.Vehicle.manufacturerId ? this.state.Vehicle.manufacturerId : ""} vehicleModelId={this.state.Vehicle && this.state.Vehicle.vehicleModelId ? this.state.Vehicle.vehicleModelId : ""}
                    vehicleSubModelId={this.state.Vehicle && this.state.Vehicle.vehicleSubModelId ? this.state.Vehicle.vehicleSubModelId : ""}
                    modelCode={this.state.Vehicle && this.state.Vehicle.modelCode ? this.state.Vehicle.modelCode : ""}
                    ClosePopup={() => this.closePopup()}
                    tozeretCd={this.state.Vehicle ? this.state.Vehicle.tozeretCd : undefined}
                    degemCd={this.state.Vehicle ? this.state.Vehicle.degemCd : undefined}
                    GetVehicleSubmodelId={this.connectVehicle}
                    year={this.state.Vehicle && this.state.Vehicle.carYear ? this.state.Vehicle.carYear : 0}
                ></VehicleDetails>
            </div>

            <div className={this.state.ShowAddressPopup ? "" : "hide"}>
                <PostalCode closePopup={() => this.closeAddressPopup()}
                    GetPostalCode={(data: string, address: CustomerAddress | null) => this.GetPostalCode(data, address)}
                    AddressChange={(data: CustomerAddress) => this.GetAddress(data)}
                    city={this.state.simulatorData ? this.state.simulatorData.city : ""}
                    open={this.state.ShowAddressPopup}
                ></PostalCode>
            </div>

        </>
        );
    }
}
